import React, { Fragment, useEffect, useState, useRef, useLayoutEffect } from 'react'
import { useAppSelector, useAppDispatch } from '../../../app/hooks';
import Select, { StylesConfig } from 'react-select';
import clsx from 'clsx';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format, parse } from 'date-fns';
import { KTIcon, toAbsoluteUrl } from '../../../_metronic/helpers';
import fetchAPI from '../../../common/fetchAPI';
import * as yup from 'yup';
import { Formik } from 'formik';
import { determineCommaSeprater, validateCultureNumber, formatNumberCustomoriginalapiv2, parseLocalizedNumber, formatNumberCustomoriginal, dropDownSelectionStyles, dateFormatByCulture, dateFormatByAccountCulture, getValueFromResource } from '../../../common/timeLiveFunction';
import { ShowToast } from '../../../common/Toastr';
import {
    addAccountEmployeeAsync, updateAccountEmployeeAsync, updateIsCanvasLoading, UploadProfiles, updateAccountEmployeeId
    , UploadElectronicSignature, isEmailAddressAvailable, checkEmailUniqueness, resetSelectedRecordObjectInState
    , getBillingAndEmployeeRateOfEmployeeOwnAsync, GetEmailAddressValidationAsync
} from './employeeSlice';
import { useTranslation } from "react-i18next";
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import Loader from '../../../common/Loader';
import CanvasLoader from '../../../common/CanvasLoader';
import { ShowSwal, ShowSwalForCanvas, ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import * as Sentry from '@sentry/react'
import fetchTimeliveAPI from '../../../common/fetchTimeliveAPI';
import { QRCodeCanvas } from 'qrcode.react';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import infoSVG from '../../../assets/image/info-SVG.svg';
import { TOOLTIP_STYLE } from '../../../common/TooltipStyle';

interface DropdownItem {
    value: number;
    label: string;
}

const objDropdown = {
    Role: [],
    Department: [],
    Location: [],
    WorkType: [],
    EmployeeRateCurrency: [],
    BillingRateCurrency: [],
    WorkingDayType: [],
    EmployeeStatus: [],
    EmployeeTimeOffPolicy: [],
    TimeOffApprovalType: [],
    EmployeeManager: [],
    TimeZone: [],
    HolidayType: [],
    EmployeeType: [],
    Shift: [],
    ExpensePolicy: [],
    Country: [],
    BillingType: [],
    UserInterfaceLanguage: [
        { label: 'English (United States)', value: 'en-US' },
        { label: 'German (Germany)', value: 'de-DE' },
        { label: 'French (France)', value: 'fr-FR' },
        { label: 'Chinese (Simplified, PRC)', value: 'zh-CN' },
        { label: 'Italian (Italy)', value: 'it-IT' },
        { label: 'Dutch (Netherlands)', value: 'nl-NL' },
        { label: 'Spanish (Spain)', value: 'es-ES' },
        { label: 'Swedish (Sweden)', value: 'sv-SE' },
        { label: 'Portuguese (Portugal)', value: 'pt-PT' },
        { label: 'Norwegian, Nynorsk (Norway)', value: 'nn-NO' },
        { label: 'Romanian (Romania)', value: 'ro-RO' },
        { label: 'Hungarian (Hungary)', value: 'hu-HU' },
        { label: 'Thai (Thailand)', value: 'th-TH' },
        { label: 'Turkish (Turkey)', value: 'tr-TR' },
        { label: 'Russian (Russia)', value: 'ru-RU' }
    ]
}

const objEmployeeValues = {
    //AccountRoleId: 0,
    //AccountDepartmentId: 0,
    //AccountLocationId: 0,
    //AccountWorkTypeId: 0,
    //EmployeeRateCurrencyId: 0,
    IsDisabled: false,
    //BillingRateCurrencyId: 0,
    AccountEmployeeId: 0,
    //AccountWorkingDayTypeId: 0,
    //AccountStatusId: 0,
    //UserInterfaceLanguageId: "",
    AccountTimeOffPolicyId: 0,
    AccountApprovalTypeId: 0,
    AccountHolidayTypeId: 0,
    //AccountEmployeeTypeId: 0,
    AccountShiftId: '',
    AccountExpensePolicyId: '',
    // CountryId: 0,
    // AccountBillingTypeId: 0,
    // TimeZoneId: 0,
    BillingRateStartDate: new Date(),
    BillingRateEndDate: new Date(),
    HiredDate: new Date(),
    TerminationDate: new Date(),
    pinCode: "",
    JobTitle: "",
    IsShowEmployeeProfilePicture: false,
    IsTimeInOutAvailable: false,
    IsForcePasswordChange: false,
    setFilesESignature: [],
    setFilesProfile: [],
    ProfilePictureColor: "",
    isCanvasLoader: true,
    AllowAttendanceFromWebApp: false,
    AttendancePolicyName: 'None',
    biometricUserId: null,
    IsTimesheetAutoApproval: false,
    employeeYup: {
        emailAddress: "", firstName: "", middleName: "", employeeCode: "", lastName: "", password: "", verifyPassword: "",
        AccountRoleId: 0,
        AccountDepartmentId: 0,
        AccountLocationId: 0,
        AccountWorkTypeId: 0,
        EmployeeRateCurrencyId: 0,
        BillingRateCurrencyId: 0,
        AccountWorkingDayTypeId: 0,
        AccountStatusId: 0,
        UserInterfaceLanguageId: "",
        //AccountApprovalTypeId: 0,
        AccountEmployeeTypeId: 0,
        CountryId: 0,
        AccountBillingTypeId: 0,
        TimeZoneId: 0,
        CustomField1: "",
        CustomField2: "",
        CustomField3: "",
        CustomField4: "",
        CustomField5: "",
        CustomField6: "",
        CustomField7: "",
        CustomField8: "",
        CustomField9: "",
        CustomField10: "",
        CustomField11: "",
        CustomField12: "",
        CustomField13: "",
        CustomField14: "",
        CustomField15: ""
    }
}

const EmployeeAddUpdate = (props: any) => {
    const { IsLicenseExpired, IsAdd, enablePasswordComplexity } = props;
    const defaultFocusRef = useRef<HTMLInputElement>(null);
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const [menuItems, setMenuItems] = useState([]);
    let currentUserId = localStorage.getItem("accountEmployeeId");
    const [tab, setTab] = useState('Basic');
    const [employeeResponse, setEmployeeResponse] = useState<any | ''>(objDropdown);
    const [employeeValues, setemployeeValues] = useState<any | ''>(objEmployeeValues);
    const { IsEmailAvailable, isEmailUnique, selectedRecord, accountemployeeid, newRecords, removeRecords, accessToken, isLoading, callEdit } = useAppSelector((state) => state.employee);
    const [pinCode, setPinCode] = useState('');
    const [FilesESignature, setFilesESignature] = useState<File[]>([]);
    const [FilesProfile, setFilesProfile] = useState<File[]>([]);
    const [profilePictureColor, setProfilePictureColor] = useState<string>('#512DA8');
    const StartDate = new Date();
    const EndDate = new Date();
    const { decimalPlaces, accountBaseCurrencyId, maxMenuHeight, countryId, sessionAccountEmployeeId, CurrentCultureDateFormat, cultureInfoName, dateInsertionFormat, customFieldInsertionFormat, masterAccountRoleId, calendarStartDay, enableUploadFeature, accountFeatureList } = useAppSelector(state => state.globalState);
    const navigate = useNavigate();
    const [data, setData] = useState<DropdownItem[]>([{ value: 0, label: 'None' }]);
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [selectedEmployee, setSelectedEmployee] = useState<DropdownItem | null>({ value: 0, label: 'None' });
    const [search, setSearch] = useState<string>('');
    const [customFieldsArray, SetCustomFieldsArray] = useState<any | ''>([]);
    const formikRef = useRef<any>(null);
    const emailmsgRef = useRef<any>();
    const [isEmailAvailabler, setisEmailAvailabler] = useState(true);
    const [showErrorSummary, setShowErrorSummary] = useState(false);
    const [emailvalidate, setEmailValidate] = useState(true);
    const [workTypeId, setWorkTypeId] = useState();
    //const [employeeRateValue, setEmployeeRateValue] = useState(0);
    //const [billingRateValue, setBillingRateValue] = useState(0);
    const [employeeRateValue, setEmployeeRateValue] = useState<string>('');
    const [billingRateValue, setBillingRateValue] = useState<string>('');
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const [isSearch, setIsSearch] = useState(false);
    const closeButtonRef = useRef<HTMLButtonElement | null>(null);
    const [previousTimeOffPolicyId, setPreviousTimeOffPolicyId] = useState(null);
    const [geofenceProfileOptions, setGeofenceProfileOptions] = useState<any[]>([]);
    const [selectedGeofenceprofile, setSelectedGeofenceProfile] = useState<any>();
    const [showQRModal, setShowQRModal] = useState(false);
    const qrRef = useRef<HTMLDivElement>(null);
    const showGeofence = accountFeatureList?.some((item: any) => item?.Id === 'a8c66b2b-db46-404d-a83f-fe797d349788') ?? false;
    const showAttendance = accountFeatureList?.some((item: any) => item?.Id === '21e65278-ab96-42c6-a332-16cafbbc669e') ?? false;


    useEffect(() => {
        const getGeofenceProfileDropdownList = async () => {
            try {
                const response = await fetchTimeliveAPI("api/GeoFenceProfile/GetAccountGeoFenceProfileForDropdown", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
                const json = await response.json();
                if (json?.StatusCode === '200') {
                    const options = [
                        { label: 'None', value: 0 },
                        ...json?.Data?.map((item: any) => ({
                            label: item?.ProfileName,
                            value: item?.AccountGeoFenceProfileId
                        }))
                    ]
                    setGeofenceProfileOptions(options);
                    setSelectedGeofenceProfile(0);
                }
            } catch (error) {
                console.log(error);
            }
        }
        getGeofenceProfileDropdownList()
    }, [])

    useEffect(() => {
        getCustomFieldTemplateByMasterEntityTypeIdAsync().then((result) => {
            renderEmployeeFields(accountemployeeid, result);
        }).catch((error) => {
            Sentry.captureException(error);
        });
        setTab('Basic');
        if (defaultFocusRef.current) {
            defaultFocusRef.current.focus();
        }
    }, [selectedRecord, accountemployeeid]);

    // useEffect(() => {
    //     if (employeeValues.AccountEmployeeId !== 0 && employeeValues.employeeYup.AccountWorkTypeId !== 0) {
    //         onDropdownChange();
    //     }
    // }, [employeeValues.AccountEmployeeId, employeeValues.employeeYup.AccountWorkTypeId]);
    useEffect(() => {
        if (employeeValues.AccountEmployeeId != 0 && workTypeId != 0 && accountemployeeid !== 0) {
            onDropdownChange();
        }
    }, [employeeValues.AccountEmployeeId, workTypeId, accountemployeeid !== 0]);

    const fetchData = async (pageNum: any, search: string) => {
        setLoading(true);
        try {
            const searchParam = search ? `&search=${search}` : "";
            const response: any = await fetchAPI(`api/V2/Employees/CurrentActiveNameAndIdForDropdown/${sessionAccountEmployeeId}?page=${pageNum}${searchParam}`, "GET", "", true);
            const json = await response.json();
            const transformedData = json.items.map((item: any) => ({
                value: item.id,
                label: item.text,
            }));
            const newItems = transformedData.filter((item: any) => !data.some((existingItem: any) => existingItem.value === item.value));
            // setData((prevData) => [...prevData, ...newItems]);
            setData((prevData) => {
                const allData = [...prevData, ...newItems];
                const uniqueData = Array.from(new Map(allData.map(item => [item.value, item])).values());
                return uniqueData;
            });
            // setHasMore(newItems.length > 0);
            if (isSearch === false) {
                setHasMore(newItems.length > 0);
            }
            setIsSearch(false);
        } catch (error) {
            Sentry.captureException(error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchData(page, search);
    }, [page, search]);

    const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
        // const bottom = e.currentTarget.scrollHeight - e.currentTarget.scrollTop === e.currentTarget.clientHeight;
        const el = e.currentTarget;
        const bottom = el.scrollHeight - el.scrollTop <= el.clientHeight + 1;
        setSearch('');
        if (bottom && hasMore && !loading) {
            setPage((prevPage) => prevPage + 1);
        }
    }

    const customMenuList = (props: any) => {
        const { children, innerRef, maxHeight, getValue } = props;
        const handleMenuScroll = (e: React.UIEvent<HTMLDivElement>) => {
            handleScroll(e);
        }
        return (
            <div onScroll={handleMenuScroll} ref={innerRef} style={{ maxHeight, overflowY: 'auto' }}>
                {children}
            </div>
        );
    }

    // const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    //     const file = event.target.files?.[0];
    //     if (file) {
    //         const validTypes = ['image/png', 'image/gif', 'image/jpeg', 'image/jpg'];
    //         if (validTypes.includes(file.type) && file.size <= 5242880) {
    //             setFilesProfile([file]);
    //             const formData = new FormData();
    //             formData.append('file', file);
    //             let param: any = {};
    //             param = { formData: formData };
    //             dispatch(UploadProfiles(param))
    //                 .then(response => {
    //                 })
    //                 .catch(error => {
    //                 });
    //         } else {
    //             alert(t('Only .png, .gif, .jpeg, .jpg files are allowed and the max file size is 5MB'));
    //         }
    //     }
    // }

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>, EmployeeId: any) => {
        const file = event.target.files?.[0];
        if (file) {
            const validTypes = ['image/png', 'image/gif', 'image/jpeg', 'image/jpg'];
            if (validTypes.includes(file.type) && file.size <= 5242880) {
                const formData = new FormData();
                formData.append('file', file);
                dispatch(UploadProfiles({ formData, EmployeeId }))
                    .then(response => {
                        console.log('Upload successful:', response);
                    })
                    .catch(error => {
                        Sentry.captureException(error);
                        console.error('Upload failed:', error);
                    });
            } else {
                alert('Only .png, .gif, .jpeg, .jpg files are allowed and the max file size is 5MB');
            }
        }
    };



    const handleFileElectronicSignature = (event: React.ChangeEvent<HTMLInputElement>, EmployeeId: any) => {
        const file = event.target.files?.[0];
        if (file) {
            const validTypes = ['image/png', 'image/gif', 'image/jpeg', 'image/jpg'];
            if (validTypes.includes(file.type) && file.size <= 5242880) {
                setFilesESignature([file]);
                const formData = new FormData();
                formData.append('file', file);
                let param: any = {};
                param = { formData: formData };
                dispatch(UploadElectronicSignature({ formData, EmployeeId }))
                    .then(response => {
                    })
                    .catch(error => {
                        Sentry.captureException(error);
                    });
            } else {
                alert(t('Only .png, .gif, .jpeg, .jpg files are allowed and the max file size is 5MB'));
            }
        }
    }

    const navigateToEmployeeSummary = (obj: any) => {
        localStorage.setItem('objEmployee', JSON.stringify(obj));
        navigate(`/employeesummary/${obj.AccountEmployeeId}`, { state: { obj } });
        /* navigate('/employeesummary', { state: { obj } }); */
    }

    const onChange = (data: any, filterName: any) => {
        setemployeeValues((employeeValues: any) => ({
            ...employeeValues,
            //AccountRoleId: filterName.name == "roleList" ? employeeResponse.Role.filter((x: any) => x.value == data.value)[0].value : employeeValues.AccountRoleId,
            //AccountDepartmentId: filterName.name == "departmentList" ? employeeResponse.Department.filter((x: any) => x.value == data.value)[0].value : employeeValues.AccountDepartmentId,
            //AccountLocationId: filterName.name == "locationList" ? employeeResponse.Location.filter((x: any) => x.value == data.value)[0].value : employeeValues.AccountLocationId,
            //CountryId: filterName.name == "countryList" ? employeeResponse.Country.filter((x: any) => x.value == data.value)[0].value : employeeValues.CountryId,
            //AccountWorkTypeId: filterName.name == "worktypeList" ? employeeResponse.WorkType.filter((x: any) => x.value == data.value)[0].value : employeeValues.AccountWorkTypeId,
            // AccountBillingTypeId: filterName.name == "billingtypeList" ? employeeResponse.BillingType.filter((x: any) => x.value == data.value)[0].value : employeeValues.AccountBillingTypeId,
            //EmployeeRateCurrencyId: filterName.name == "employeeratecurrencyList" ? employeeResponse.EmployeeRateCurrency.filter((x: any) => x.value == data.value)[0].value : employeeValues.EmployeeRateCurrencyId,
            //BillingRateCurrencyId: filterName.name == "billingratecurrencyList" ? employeeResponse.BillingRateCurrency.filter((x: any) => x.value == data.value)[0].value : employeeValues.BillingRateCurrencyId,
            //AccountWorkingDayTypeId: filterName.name == "workingdaytypeList" ? employeeResponse.WorkingDayType.filter((x: any) => x.value == data.value)[0].value : employeeValues.AccountWorkingDayTypeId,
            //AccountStatusId: filterName.name == "employeestatusList" ? employeeResponse.EmployeeStatus.filter((x: any) => x.value == data.value)[0].value : employeeValues.AccountStatusId,
            AccountTimeOffPolicyId: filterName.name == "employeetimeoffpolicyList" ? employeeResponse.EmployeeTimeOffPolicy.filter((x: any) => x.value == data.value)[0].value : employeeValues.AccountTimeOffPolicyId,
            AccountApprovalTypeId: filterName.name == "timeoffapprovaltypeList" ? employeeResponse.TimeOffApprovalType.filter((x: any) => x.value == data.value)[0].value : employeeValues.AccountApprovalTypeId,
            EmployeeManagerId: filterName.name == "employeemanagerList" ? employeeResponse.EmployeeManager.filter((x: any) => x.value == data.value)[0].value : employeeValues.EmployeeManagerId,
            AccountHolidayTypeId: filterName.name == "holidaytypeList" ? employeeResponse.HolidayType.filter((x: any) => x.value == data.value)[0].value : employeeValues.AccountHolidayTypeId,
            //TimeZoneId: filterName.name == "timezoneList" ? employeeResponse.TimeZone.filter((x: any) => x.value == data.value)[0].value : employeeValues.TimeZoneId,
            //AccountEmployeeTypeId: filterName.name == "employeetypeList" ? employeeResponse.EmployeeType.filter((x: any) => x.value == data.value)[0].value : employeeValues.AccountEmployeeTypeId,
            AccountShiftId: filterName.name == "shiftList" ? employeeResponse.Shift.filter((x: any) => x.value == data.value)[0].value : employeeValues.AccountShiftId,
            AccountExpensePolicyId: filterName.name == "expensepolicyList" ? employeeResponse.ExpensePolicy.filter((x: any) => x.value == data.value)[0].value : employeeValues.AccountExpensePolicyId,
            //UserInterfaceLanguageId: filterName.name == "userintefacelanguageList" ? employeeResponse.UserInterfaceLanguage.filter((x: any) => x.value == data.value)[0].value : employeeValues.UserInterfaceLanguageId
            
        }));
    }



    const handleTextChange = (e: any) => {
        setemployeeValues({ ...employeeValues, [e.target.id]: e.target.value })
    }

    function onDropdownChange1(data?: any): void {
        const { value, label } = data;
        setemployeeValues({
            ...employeeValues,
            AccountWorkTypeId: value
        });
    }

    function onDropdownChange(): void {
        const updatedEmployeeYup = { ...employeeValues.employeeYup };
        dispatch(getBillingAndEmployeeRateOfEmployeeOwnAsync({ AccountWorkTypeId: workTypeId, AccountEmployeeId: accountemployeeid, decimalPlaces: decimalPlaces, cultureInfoName: cultureInfoName.toString() }))
            .then((response) => {
                if (response.payload.AccountWorkType.length > 0) {
                    const accountWorkTypeData = response.payload.AccountWorkType[0];
                    updatedEmployeeYup.AccountWorkTypeId = accountWorkTypeData.AccountWorkTypeId;
                    updatedEmployeeYup.BillingRateCurrencyId = accountWorkTypeData.BillingRateCurrencyId;
                    updatedEmployeeYup.EmployeeRateCurrencyId = accountWorkTypeData.EmployeeRateCurrencyId;
                    // Format the billing rate
                    const formattedBillingRate = formatNumberCustomoriginalapiv2(
                        cultureInfoName.toString(),
                        accountWorkTypeData.BillingRate,
                        decimalPlaces
                    );
                    const formattedEmployeeRate = formatNumberCustomoriginalapiv2(
                        cultureInfoName.toString(),
                        accountWorkTypeData.EmployeeRate,
                        decimalPlaces
                    );
                    //setEmployeeRateValue(accountWorkTypeData.EmployeeRate);
                    //setEmployeeRateValue(accountWorkTypeData.BillingRate);
                    setBillingRateValue(formattedBillingRate);
                    setEmployeeRateValue(formattedEmployeeRate);
                    setemployeeValues({
                        ...employeeValues,
                        employeeYup: updatedEmployeeYup,
                        //BillingRate: formatNumberCustomoriginalapiv2(cultureInfoName.toString(), accountWorkTypeData.BillingRate, decimalPlaces),
                        //BillingRate: formattedBillingRate,
                        //BillingRate: accountWorkTypeData.BillingRate,
                        //EmployeeRate: accountWorkTypeData.EmployeeRate,
                        // BillingRateStartDate: moment(accountWorkTypeData.StartDate).toDate(),
                        // BillingRateEndDate: moment(accountWorkTypeData.EndDate).toDate(),
                        BillingRateStartDate: dateFormatByAccountCulture(moment.parseZone(accountWorkTypeData.StartDate).format(dateInsertionFormat), cultureInfoName.toString()),
                        BillingRateEndDate: dateFormatByAccountCulture(moment.parseZone(accountWorkTypeData.EndDate).format(dateInsertionFormat), cultureInfoName.toString())
                    });
                    // setemployeeValues({
                    //     ...employeeValues,
                    //     BillingRate: accountWorkTypeData.BillingRate,
                    //     EmployeeRate: accountWorkTypeData.EmployeeRate,
                    //     BillingRateStartDate: moment(accountWorkTypeData.StartDate).toDate(),
                    //     BillingRateEndDate: moment(accountWorkTypeData.EndDate).toDate(),
                    //     BillingRateCurrencyId: accountWorkTypeData.BillingRateCurrencyId,
                    //     EmployeeRateCurrencyId: accountWorkTypeData.EmployeeRateCurrencyId,
                    //     AccountWorkTypeId: accountWorkTypeData.AccountWorkTypeId
                    // });
                } else {
                    updatedEmployeeYup.AccountWorkTypeId = updatedEmployeeYup.AccountWorkTypeId;
                    updatedEmployeeYup.BillingRateCurrencyId = accountBaseCurrencyId;
                    updatedEmployeeYup.EmployeeRateCurrencyId = accountBaseCurrencyId;
                    const formattedBillingRate = formatNumberCustomoriginalapiv2(
                        cultureInfoName.toString(),
                        0,
                        decimalPlaces
                    );
                    const formattedEmployeeRate = formatNumberCustomoriginalapiv2(
                        cultureInfoName.toString(),
                        0,
                        decimalPlaces
                    );
                    setEmployeeRateValue('');
                    setBillingRateValue('');
                    setemployeeValues({
                        ...employeeValues,
                        employeeYup: updatedEmployeeYup,
                        BillingRate: 0,
                        EmployeeRate: 0,
                        // BillingRateStartDate: moment(StartDate).toDate(),
                        // BillingRateEndDate: moment(EndDate).toDate(),
                        BillingRateStartDate: dateFormatByAccountCulture(StartDate, cultureInfoName.toString()),
                        BillingRateEndDate: dateFormatByAccountCulture(EndDate, cultureInfoName.toString())
                    });
                    // setemployeeValues({
                    //     ...employeeValues,
                    //     BillingRate: 0,
                    //     EmployeeRate: 0,
                    //     BillingRateStartDate: moment(StartDate).toDate(),
                    //     BillingRateEndDate: moment(EndDate).toDate(),
                    //     BillingRateCurrencyId: accountBaseCurrencyId,
                    //     EmployeeRateCurrencyId: accountBaseCurrencyId,
                    //     AccountWorkTypeId: employeeValues.employeeYup.AccountWorkTypeId
                    // });
                }
            })
            .catch((error) => {
                Sentry.captureException(error);
            });
    }

    const getCustomFieldTemplateByMasterEntityTypeIdAsync = async () => {
        let MasterEntityTypeId: string = '3601AE9B-3F82-4C80-9574-751F9A124FA8';
        const response = await fetchAPI('api/v2/CustomFields/CustomFieldTemplateByMasterEntityType/' + MasterEntityTypeId, 'GET', '', true, accessToken);
        const json = await response.json();
        if (json.length > 0) {
            SetCustomFieldsArray(json);
        }
        else {
            SetCustomFieldsArray([]);
        }
        return json;
    }

    const renderDropDowns = async (json: any) => {
        json.Data["Active Roles"].map((item: any) => {
            item.value = item.AccountRoleId;
            item.label = item.Role;
            delete item.AccountRoleId;
            delete item.Role;
        });
        json.Data["Active Location"].map((item: any) => {
            item.value = item.AccountLocationId;
            item.label = item.AccountLocation;
            delete item.AccountLocationId;
            delete item.AccountLocation;
        });
        json.Data["Active Account Work Type"].map((item: any) => {
            item.value = item.AccountWorkTypeId;
            item.label = item.AccountWorkType;
            delete item.AccountWorkTypeId;
            delete item.AccountWorkType;
        });
        json.Data["Active Departments"].map((item: any) => {
            item.value = item.AccountDepartmentId;
            item.label = item.DepartmentName;
            delete item.AccountDepartmentId;
            delete item.DepartmentName;
        });
        json.Data["Employee Rate Currency"].map((item: any) => {
            item.value = item.AccountCurrencyId;
            item.label = item.CurrencyCode;
            delete item.AccountCurrencyId;
            delete item.CurrencyCode;
        });
        json.Data["Billing Rate Currency"].map((item: any) => {
            item.value = item.AccountCurrencyId;
            item.label = item.CurrencyCode;
            delete item.AccountCurrencyId;
            delete item.CurrencyCode;
        });
        json.Data["Active Working Day Type"].map((item: any) => {
            item.value = item.AccountWorkingDayTypeId;
            item.label = item.AccountWorkingDayType;
            delete item.AccountWorkingDayTypeId;
            delete item.AccountWorkingDayType;
        });
        json.Data["Active Employee Status"].map((item: any) => {
            item.value = item.AccountStatusId;
            item.label = item.Status;
            delete item.AccountStatusId;
            delete item.Status;
        });
        json.Data["Active Employee Time Off Policy"].map((item: any) => {
            item.value = item.AccountTimeOffPolicyId;
            item.label = item.AccountTimeOffPolicy;
            delete item.AccountTimeOffPolicyId;
            delete item.AccountTimeOffPolicy;
        });
        json.Data["Active Employee Time Off Policy"].unshift({ value: '', label: 'None' });
        json.Data["Active Time Off Approval Type"].map((item: any) => {
            item.value = item.AccountApprovalTypeId;
            item.label = item.ApprovalTypeName;
            delete item.AccountApprovalTypeId;
            delete item.ApprovalTypeName;
        });
        json.Data["Active Time Off Approval Type"].unshift({ value: 0, label: 'Approval Not Required' });
        json.Data["Active Account Holiday Type"].map((item: any) => {
            item.value = item.AccountHolidayTypeId;
            item.label = item.AccountHolidayType;
            delete item.AccountHolidayTypeId;
            delete item.AccountHolidayType;
        });
        json.Data["Active Account Holiday Type"].unshift({ value: '', label: 'None' });
        json.Data["Active Employee Type"].map((item: any) => {
            item.value = item.AccountEmployeeTypeId;
            item.label = item.AccountEmployeeType;
            delete item.AccountEmployeeTypeId;
            delete item.AccountEmployeeType;
        });
        json.Data["Account Shift"].map((item: any) => {
            item.value = item.AccountShiftId;
            item.label = item.Name;
            delete item.AccountShiftId;
            delete item.Name;
        });
        json.Data["Account Shift"].unshift({ value: '', label: 'None' });
        json.Data["Account Expense Policy"].map((item: any) => {
            item.value = item.AccountExpensePolicyId;
            item.label = item.ExpensePolicyName;
            delete item.AccountExpensePolicyId;
            delete item.ExpensePolicyName;
        });
        json.Data["Account Expense Policy"].unshift({ value: '', label: 'None' });
        json.Data["Active Countries"].map((item: any) => {
            item.value = item.CountryId;
            item.label = item.Country;
            delete item.CountryId;
            delete item.Country;
        });
        json.Data["Active BillingType"].map((item: any) => {
            item.value = item.AccountBillingTypeId;
            item.label = item.BillingType;
            delete item.AccountBillingTypeId;
            delete item.BillingType;
        });
        json.Data["Active EmployeeManager"].map((item: any) => {
            item.value = item.AccountEmployeeId;
            item.label = item.FullName;
            delete item.AccountEmployeeId;
            delete item.FullName;
        });
        json.Data["Active EmployeeManager"].unshift({ value: 0, label: 'None' });
        json.Data["Active TimeZone"].map((item: any) => {
            // console.log('json.Data["Active TimeZone"]',json.Data["Active TimeZone"])
            item.value = item.SystemTimeZoneId;
            item.label = item.TimeZoneName;
            delete item.SystemTimeZoneId;
            delete item.TimeZone;
        });
    }

    const renderEmployeeFields = async (AccountEmployeeId: number, customFields: any) => {
        if (formikRef.current) {
            formikRef.current.resetForm();
        }

        setemployeeValues({
            ...employeeValues,
            isCanvasLoader: true
        })
        const response = await fetchAPI('api/V2/Employees/SingleRequest?AccountEmployeeId=' + AccountEmployeeId, 'Get', '', true, accessToken);
        const json = await response.json();
        await renderDropDowns(json);
        const initialWorkTypeId = json.Data["Active Account Work Type"]?.length > 0
            ? json.Data["Active Account Work Type"][0].value
            : 0;
        setWorkTypeId(initialWorkTypeId);
        setEmployeeResponse({
            ...employeeResponse,
            Role: json.Data["Active Roles"],
            Department: json.Data["Active Departments"],
            Location: json.Data["Active Location"],
            WorkType: json.Data["Active Account Work Type"],
            EmployeeRateCurrency: json.Data["Employee Rate Currency"],
            BillingRateCurrency: json.Data["Billing Rate Currency"],
            WorkingDayType: json.Data["Active Working Day Type"],
            EmployeeStatus: json.Data["Active Employee Status"],
            EmployeeTimeOffPolicy: json.Data["Active Employee Time Off Policy"],
            TimeOffApprovalType: json.Data["Active Time Off Approval Type"],
            HolidayType: json.Data["Active Account Holiday Type"],
            EmployeeType: json.Data["Active Employee Type"],
            Shift: json.Data["Account Shift"],
            ExpensePolicy: json.Data["Account Expense Policy"],
            Country: json.Data["Active Countries"],
            BillingType: json.Data["Active BillingType"],
            EmployeeManager: json.Data["Active EmployeeManager"],
            TimeZone: json.Data["Active TimeZone"]
        })
        if (accountemployeeid === 0) {
            const updatedEmployeeYup = { ...employeeValues.employeeYup };
            updatedEmployeeYup.emailAddress = "";
            updatedEmployeeYup.firstName = "";
            updatedEmployeeYup.lastName = "";
            updatedEmployeeYup.password = "";
            updatedEmployeeYup.verifyPassword = "";
            updatedEmployeeYup.AccountRoleId = json.Data["Active Roles"] ?
                json.Data["Active Roles"].length > 0 ? json.Data["Active Roles"][0].value : 0
                : 0;
            updatedEmployeeYup.AccountDepartmentId = json.Data["Active Departments"] ?
                json.Data["Active Departments"].length > 0 ? json.Data["Active Departments"][0].value : 0
                : 0;
            updatedEmployeeYup.AccountLocationId = json.Data["Active Location"] ?
                json.Data["Active Location"].length > 0 ? json.Data["Active Location"][0].value : 0
                : 0;
            updatedEmployeeYup.AccountWorkTypeId = json.Data["Active Account Work Type"] ?
                json.Data["Active Account Work Type"].length > 0 ? json.Data["Active Account Work Type"][0].value : 0
                : 0;
            // updatedEmployeeYup.EmployeeRateCurrencyId = json.Data["Employee Rate Currency"] ?
            //     json.Data["Employee Rate Currency"].length > 0 ? json.Data["Employee Rate Currency"][0].value : 0
            //     : 0;
            // updatedEmployeeYup.BillingRateCurrencyId = json.Data["Billing Rate Currency"] ?
            //     json.Data["Billing Rate Currency"].length > 0 ? json.Data["Billing Rate Currency"][0].value : 0
            //     : 0;
            updatedEmployeeYup.EmployeeRateCurrencyId = accountBaseCurrencyId;
            updatedEmployeeYup.BillingRateCurrencyId = accountBaseCurrencyId;
            updatedEmployeeYup.AccountWorkingDayTypeId = json.Data["Active Working Day Type"] ?
                json.Data["Active Working Day Type"].length > 0 ? json.Data["Active Working Day Type"][0].value : 0
                : 0;
            updatedEmployeeYup.AccountStatusId = json.Data["Active Employee Status"] ?
                json.Data["Active Employee Status"].length > 0 ? json.Data["Active Employee Status"][0].value : 0
                : 0;
            // updatedEmployeeYup.AccountApprovalTypeId = json.Data["Active Time Off Approval Type"] ?
            //     json.Data["Active Time Off Approval Type"].length > 0 ? json.Data["Active Time Off Approval Type"][0].value : 0
            //     : 0;
            updatedEmployeeYup.AccountEmployeeTypeId = json.Data["Active Employee Type"] ?
                json.Data["Active Employee Type"].length > 0 ? json.Data["Active Employee Type"][0].value : 0
                : 0;
            updatedEmployeeYup.UserInterfaceLanguageId = "en-US";
            updatedEmployeeYup.CountryId = countryId;
            updatedEmployeeYup.AccountBillingTypeId = json.Data["Active BillingType"] ?
                json.Data["Active BillingType"].length > 0 ? json.Data["Active BillingType"][0].value : 0
                : 0;
            updatedEmployeeYup.TimeZoneId = json.Data["Active TimeZone"] ?
                json.Data["Active TimeZone"].length > 0 ? json.Data["Active TimeZone"][0].value : 0
                : 0;
            updatedEmployeeYup.CustomField1 = getDefaultValOfSpecificCustomField('CustomField1', customFields);
            updatedEmployeeYup.CustomField2 = getDefaultValOfSpecificCustomField('CustomField2', customFields);
            updatedEmployeeYup.CustomField3 = getDefaultValOfSpecificCustomField('CustomField3', customFields);
            updatedEmployeeYup.CustomField4 = getDefaultValOfSpecificCustomField('CustomField4', customFields);
            updatedEmployeeYup.CustomField5 = getDefaultValOfSpecificCustomField('CustomField5', customFields);
            updatedEmployeeYup.CustomField6 = getDefaultValOfSpecificCustomField('CustomField6', customFields);
            updatedEmployeeYup.CustomField7 = getDefaultValOfSpecificCustomField('CustomField7', customFields);
            updatedEmployeeYup.CustomField8 = getDefaultValOfSpecificCustomField('CustomField8', customFields);
            updatedEmployeeYup.CustomField9 = getDefaultValOfSpecificCustomField('CustomField9', customFields);
            updatedEmployeeYup.CustomField10 = getDefaultValOfSpecificCustomField('CustomField10', customFields);
            updatedEmployeeYup.CustomField11 = getDefaultValOfSpecificCustomField('CustomField11', customFields);
            updatedEmployeeYup.CustomField12 = getDefaultValOfSpecificCustomField('CustomField12', customFields);
            updatedEmployeeYup.CustomField13 = getDefaultValOfSpecificCustomField('CustomField13', customFields);
            updatedEmployeeYup.CustomField14 = getDefaultValOfSpecificCustomField('CustomField14', customFields);
            updatedEmployeeYup.CustomField15 = getDefaultValOfSpecificCustomField('CustomField15', customFields);
            setemployeeValues({
                ...employeeValues,
                employeeYup: updatedEmployeeYup,
                // AccountRoleId: json.Data["Active Roles"] ?
                //     (json.Data["Active Roles"].length > 0 ? json.Data["Active Roles"][0].value : '') :
                //     '',
                // AccountDepartmentId: json.Data["Active Departments"] ?
                //     (json.Data["Active Departments"].length > 0 ? json.Data["Active Departments"][0].value : '') :
                //     '',
                // AccountLocationId: json.Data["Active Location"] ?
                //     json.Data["Active Location"].length > 0 ? json.Data["Active Location"][0].value : ''
                //     : '',
                // AccountWorkTypeId: json.Data["Active Account Work Type"] ?
                //     json.Data["Active Account Work Type"].length > 0 ? json.Data["Active Account Work Type"][0].value : ''
                //     : '',
                // EmployeeRateCurrencyId: json.Data["Employee Rate Currency"] ?
                //     (json.Data["Employee Rate Currency"].length > 0 ? json.Data["Employee Rate Currency"].filter((x: any) => x.value == accountBaseCurrencyId)[0].value : '') :
                //     '',
                // BillingRateCurrencyId: json.Data["Billing Rate Currency"] ?
                //     (json.Data["Billing Rate Currency"].length > 0 ? json.Data["Billing Rate Currency"].filter((x: any) => x.value == accountBaseCurrencyId)[0].value : '') :
                //     '',
                // AccountWorkingDayTypeId: json.Data["Active Working Day Type"] ?
                //     json.Data["Active Working Day Type"].length > 0 ? json.Data["Active Working Day Type"][0].value : ''
                //     : '',
                // AccountStatusId: json.Data["Active Employee Status"] ?
                //     json.Data["Active Employee Status"].length > 0 ? json.Data["Active Employee Status"][0].value : ''
                //     : '',
                AccountTimeOffPolicyId: json.Data["Active Employee Time Off Policy"] ?
                    json.Data["Active Employee Time Off Policy"].length > 0 ? json.Data["Active Employee Time Off Policy"][0].value : ''
                    : '',
                AccountApprovalTypeId: json.Data["Active Time Off Approval Type"] ?
                    json.Data["Active Time Off Approval Type"].length > 0 ? json.Data["Active Time Off Approval Type"][0].value : ''
                    : '',
                AccountHolidayTypeId: json.Data["Active Account Holiday Type"] ?
                    json.Data["Active Account Holiday Type"].length > 0 ? json.Data["Active Account Holiday Type"][0].value : ''
                    : '',
                // AccountEmployeeTypeId: json.Data["Active Employee Type"] ?
                //     json.Data["Active Employee Type"].length > 0 ? json.Data["Active Employee Type"][0].value : ''
                //     : '',
                AccountShiftId: json.Data["Account Shift"] ?
                    json.Data["Account Shift"].length > 0 ? json.Data["Account Shift"][0].value : ''
                    : '',
                AccountExpensePolicyId: json.Data["Account Expense Policy"] ?
                    json.Data["Account Expense Policy"].length > 0 ? json.Data["Account Expense Policy"][0].value : ''
                    : '',
                //CountryId: countryId,
                // AccountBillingTypeId: json.Data["Active BillingType"] ?
                //     json.Data["Active BillingType"].length > 0 ? json.Data["Active BillingType"][0].value : ''
                //     : '',
                // EmployeeManagerId: json.Data["Active EmployeeManager"] ?
                // json.Data["Active EmployeeManager"].length > 0 ? json.Data["Active EmployeeManager"][0].value : ''
                // : '',
                // TimeZoneId: json.Data["Active TimeZone"] ?
                //     json.Data["Active TimeZone"].length > 0 ? json.Data["Active TimeZone"][0].value : ''
                //     : '',
                EmployeeCode: "",
                MiddleName: "",
                AddressLine1: "",
                AddressLine2: "",
                City: "",
                State: "",
                Zip: "",
                HomePhoneNo: "",
                WorkPhoneNo: "",
                MobilePhoneNo: "",
                EmployeeRate: 0,
                BillingRate: 0,
                //UserInterfaceLanguageId: "en-US",
                pinCode: json.Data["Employee Pin"],
                ProfilePictureColor: "#512DA8",
                TerminationDate: null,
                // BillingRateStartDate: moment().toDate(),
                // BillingRateEndDate: moment().toDate(),
                BillingRateStartDate: new Date(),
                BillingRateEndDate: new Date(),
                JobTitle: "",
                // HiredDate: moment().toDate(),
                HiredDate: new Date(),
                IsShowEmployeeProfilePicture: false,
                IsTimeInOutAvailable: false,
                IsForcePasswordChange: false,
                isCanvasLoader: false,
                IsTimesheetAutoApproval: false,
                biometricUserId: null,
                AllowAttendanceFromWebApp: false
            })
            setSelectedEmployee({ value: 0, label: 'None' });
        }

        if (accountemployeeid !== 0) {
            const updatedEmployeeYup = { ...employeeValues.employeeYup };
            updatedEmployeeYup.emailAddress = json.Data["Employee"][0].EMailAddress;
            updatedEmployeeYup.firstName = json.Data["Employee"][0].FirstName;
            updatedEmployeeYup.lastName = json.Data["Employee"][0].LastName;
            updatedEmployeeYup.password = "";
            updatedEmployeeYup.verifyPassword = "";
            updatedEmployeeYup.AccountRoleId = json.Data["Employee"][0].AccountRoleId;
            updatedEmployeeYup.AccountDepartmentId = json.Data["Employee"][0].AccountDepartmentId;
            updatedEmployeeYup.AccountLocationId = json.Data["Employee"][0].AccountLocationId;
            updatedEmployeeYup.AccountWorkTypeId = json.Data["Active Account Work Type"][0].value;
            updatedEmployeeYup.AccountWorkingDayTypeId = json.Data["Employee"][0].AccountWorkingDayTypeId;
            updatedEmployeeYup.AccountStatusId = json.Data["Employee"][0].StatusId !== null ? json.Data["Employee"][0].StatusId : json.Data["Active Employee Status"][0].value;
            // updatedEmployeeYup.AccountApprovalTypeId = json.Data["Employee"][0].TimeOffApprovalTypeId;
            updatedEmployeeYup.AccountEmployeeTypeId = json.Data["Employee"][0].EmployeePayTypeId;
            updatedEmployeeYup.UserInterfaceLanguageId = json.Data["Employee"][0].UserInterfaceLanguage;
            updatedEmployeeYup.CountryId = json.Data["Employee"][0].EmployeeCountryId;
            updatedEmployeeYup.AccountBillingTypeId = json.Data["Employee"][0].AccountBillingTypeId === null ? json.Data["Active BillingType"][0].value : json.Data["Employee"][0].AccountBillingTypeId;
            updatedEmployeeYup.TimeZoneId = json.Data["Employee"][0].EmployeeTimeZoneId;
            // updatedEmployeeYup.EmployeeRateCurrencyId =  json.Data["Employee"][0].EmployeeRateCurrencyId;
            // updatedEmployeeYup.BillingRateCurrencyId =  json.Data["Employee"][0].BillingRateCurrencyId;
            // updatedEmployeeYup.CustomField1 = json.Data["Employee"][0].CustomField1 ? json.Data["Employee"][0].CustomField1 : getDefaultValOfSpecificCustomField('CustomField1', customFields);
            // updatedEmployeeYup.CustomField2 = json.Data["Employee"][0].CustomField2 ? json.Data["Employee"][0].CustomField2 : getDefaultValOfSpecificCustomField('CustomField2', customFields);
            // updatedEmployeeYup.CustomField3 = json.Data["Employee"][0].CustomField3 ? json.Data["Employee"][0].CustomField3 : getDefaultValOfSpecificCustomField('CustomField3', customFields);
            // updatedEmployeeYup.CustomField4 = json.Data["Employee"][0].CustomField4 ? json.Data["Employee"][0].CustomField4 : getDefaultValOfSpecificCustomField('CustomField4', customFields);
            // updatedEmployeeYup.CustomField5 = json.Data["Employee"][0].CustomField5 ? json.Data["Employee"][0].CustomField5 : getDefaultValOfSpecificCustomField('CustomField5', customFields);
            // updatedEmployeeYup.CustomField6 = json.Data["Employee"][0].CustomField6 ? json.Data["Employee"][0].CustomField6 : getDefaultValOfSpecificCustomField('CustomField6', customFields);
            // updatedEmployeeYup.CustomField7 = json.Data["Employee"][0].CustomField7 ? json.Data["Employee"][0].CustomField7 : getDefaultValOfSpecificCustomField('CustomField7', customFields);
            // updatedEmployeeYup.CustomField8 = json.Data["Employee"][0].CustomField8 ? json.Data["Employee"][0].CustomField8 : getDefaultValOfSpecificCustomField('CustomField8', customFields);
            // updatedEmployeeYup.CustomField9 = json.Data["Employee"][0].CustomField9 ? json.Data["Employee"][0].CustomField9 : getDefaultValOfSpecificCustomField('CustomField9', customFields);
            // updatedEmployeeYup.CustomField10 = json.Data["Employee"][0].CustomField10 ? json.Data["Employee"][0].CustomField10 : getDefaultValOfSpecificCustomField('CustomField10', customFields);
            // updatedEmployeeYup.CustomField11 = json.Data["Employee"][0].CustomField11 ? json.Data["Employee"][0].CustomField11 : getDefaultValOfSpecificCustomField('CustomField11', customFields);
            // updatedEmployeeYup.CustomField12 = json.Data["Employee"][0].CustomField12 ? json.Data["Employee"][0].CustomField12 : getDefaultValOfSpecificCustomField('CustomField12', customFields);
            // updatedEmployeeYup.CustomField13 = json.Data["Employee"][0].CustomField13 ? json.Data["Employee"][0].CustomField13 : getDefaultValOfSpecificCustomField('CustomField13', customFields);
            // updatedEmployeeYup.CustomField14 = json.Data["Employee"][0].CustomField14 ? json.Data["Employee"][0].CustomField14 : getDefaultValOfSpecificCustomField('CustomField14', customFields);
            // updatedEmployeeYup.CustomField15 = json.Data["Employee"][0].CustomField15 ? json.Data["Employee"][0].CustomField15 : getDefaultValOfSpecificCustomField('CustomField15', customFields);
            updatedEmployeeYup.CustomField1 = json.Data["Employee"][0].CustomField1 ? setCustomFieldValues('CustomField1', json.Data["Employee"][0].CustomField1, customFields) : getDefaultValOfSpecificCustomField('CustomField1', customFields);
            updatedEmployeeYup.CustomField2 = json.Data["Employee"][0].CustomField2 ? setCustomFieldValues('CustomField2', json.Data["Employee"][0].CustomField2, customFields) : getDefaultValOfSpecificCustomField('CustomField2', customFields);
            updatedEmployeeYup.CustomField3 = json.Data["Employee"][0].CustomField3 ? setCustomFieldValues('CustomField3', json.Data["Employee"][0].CustomField3, customFields) : getDefaultValOfSpecificCustomField('CustomField3', customFields);
            updatedEmployeeYup.CustomField4 = json.Data["Employee"][0].CustomField4 ? setCustomFieldValues('CustomField4', json.Data["Employee"][0].CustomField4, customFields) : getDefaultValOfSpecificCustomField('CustomField4', customFields);
            updatedEmployeeYup.CustomField5 = json.Data["Employee"][0].CustomField5 ? setCustomFieldValues('CustomField5', json.Data["Employee"][0].CustomField5, customFields) : getDefaultValOfSpecificCustomField('CustomField5', customFields);
            updatedEmployeeYup.CustomField6 = json.Data["Employee"][0].CustomField6 ? setCustomFieldValues('CustomField6', json.Data["Employee"][0].CustomField6, customFields) : getDefaultValOfSpecificCustomField('CustomField6', customFields);
            updatedEmployeeYup.CustomField7 = json.Data["Employee"][0].CustomField7 ? setCustomFieldValues('CustomField7', json.Data["Employee"][0].CustomField7, customFields) : getDefaultValOfSpecificCustomField('CustomField7', customFields);
            updatedEmployeeYup.CustomField8 = json.Data["Employee"][0].CustomField8 ? setCustomFieldValues('CustomField8', json.Data["Employee"][0].CustomField8, customFields) : getDefaultValOfSpecificCustomField('CustomField8', customFields);
            updatedEmployeeYup.CustomField9 = json.Data["Employee"][0].CustomField9 ? setCustomFieldValues('CustomField9', json.Data["Employee"][0].CustomField9, customFields) : getDefaultValOfSpecificCustomField('CustomField9', customFields);
            updatedEmployeeYup.CustomField10 = json.Data["Employee"][0].CustomField10 ? setCustomFieldValues('CustomField10', json.Data["Employee"][0].CustomField10, customFields) : getDefaultValOfSpecificCustomField('CustomField10', customFields);
            updatedEmployeeYup.CustomField11 = json.Data["Employee"][0].CustomField11 ? setCustomFieldValues('CustomField11', json.Data["Employee"][0].CustomField11, customFields) : getDefaultValOfSpecificCustomField('CustomField11', customFields);
            updatedEmployeeYup.CustomField12 = json.Data["Employee"][0].CustomField12 ? setCustomFieldValues('CustomField12', json.Data["Employee"][0].CustomField12, customFields) : getDefaultValOfSpecificCustomField('CustomField12', customFields);
            updatedEmployeeYup.CustomField13 = json.Data["Employee"][0].CustomField13 ? setCustomFieldValues('CustomField13', json.Data["Employee"][0].CustomField13, customFields) : getDefaultValOfSpecificCustomField('CustomField13', customFields);
            updatedEmployeeYup.CustomField14 = json.Data["Employee"][0].CustomField14 ? setCustomFieldValues('CustomField14', json.Data["Employee"][0].CustomField14, customFields) : getDefaultValOfSpecificCustomField('CustomField14', customFields);
            updatedEmployeeYup.CustomField15 = json.Data["Employee"][0].CustomField15 ? setCustomFieldValues('CustomField15', json.Data["Employee"][0].CustomField15, customFields) : getDefaultValOfSpecificCustomField('CustomField15', customFields);
            setemployeeValues({
                ...employeeValues,
                employeeYup: updatedEmployeeYup,
                EmployeeCode: json.Data["Employee"][0].EmployeeCode,
                MiddleName: json.Data["Employee"][0].MiddleName,
                AddressLine1: json.Data["Employee"][0].AddressLine1,
                AddressLine2: json.Data["Employee"][0].AddressLine2,
                City: json.Data["Employee"][0].City,
                State: json.Data["Employee"][0].State,
                HomePhoneNo: json.Data["Employee"][0].HomePhoneNo,
                WorkPhoneNo: json.Data["Employee"][0].WorkPhoneNo,
                MobilePhoneNo: json.Data["Employee"][0].MobilePhoneNo,
                Zip: json.Data["Employee"][0].Zip,
                AccountEmployeeId: accountemployeeid,
                //AccountRoleId: json.Data["Employee"][0].AccountRoleId,
                // AccountDepartmentId: json.Data["Employee"][0].AccountDepartmentId,
                // AccountLocationId: json.Data["Employee"][0].AccountLocationId,
                // AccountWorkTypeId: json.Data["Active Account Work Type"][0].value,
                //AccountWorkingDayTypeId: json.Data["Employee"][0].AccountWorkingDayTypeId,
                // AccountStatusId: json.Data["Employee"][0].StatusId,
                AccountTimeOffPolicyId: json.Data["Employee"][0].AccountTimeOffPolicyId !== null ? json.Data["Employee"][0].AccountTimeOffPolicyId : json.Data["Active Employee Time Off Policy"][0].value,
                // AccountApprovalTypeId: json.Data["Employee"][0].TimeOffApprovalTypeId,
                AccountApprovalTypeId: json.Data["Employee"][0].TimeOffApprovalTypeId !== null ? json.Data["Employee"][0].TimeOffApprovalTypeId : json.Data["Active Time Off Approval Type"][0].value,
                AccountHolidayTypeId: json.Data["Employee"][0].AccountHolidayTypeId !== null ? json.Data["Employee"][0].AccountHolidayTypeId : json.Data["Active Account Holiday Type"][0].value,
                //AccountEmployeeTypeId: json.Data["Employee"][0].EmployeePayTypeId,
                AccountShiftId: json.Data["Employee"][0].AccountShiftId !== null ? json.Data["Employee"][0].AccountShiftId : json.Data["Account Shift"][0].value,
                IsDisabled: json.Data["Employee"][0].IsDisabled,
                AccountExpensePolicyId: json.Data["Employee"][0].AccountExpensePolicyId !== null ? json.Data["Employee"][0].AccountExpensePolicyId : json.Data["Account Expense Policy"][0].value,
                // CountryId: json.Data["Employee"][0].EmployeeCountryId,
                // AccountBillingTypeId: json.Data["Employee"][0].AccountBillingTypeId === null ? json.Data["Active BillingType"][0].value : json.Data["Employee"][0].AccountBillingTypeId,
                // EmployeeManagerId: json.Data["Employee"][0].EmployeeManagerId,
                // TimeZoneId: json.Data["Employee"][0].EmployeeTimeZoneId,
                // UserInterfaceLanguageId: json.Data["Employee"][0].UserInterfaceLanguage,
                pinCode: json.Data["Employee"][0].EmployeePin,
                JobTitle: json.Data["Employee"][0].JobTitle,
                ProfilePictureColor: json.Data["Employee"][0].ProfilePictureColor,
                IsShowEmployeeProfilePicture: json.Data["Employee"][0].IsShowEmployeeProfilePicture,
                IsTimeInOutAvailable: json.Data["Employee"][0].IsTimeInOutAvailable,
                IsForcePasswordChange: json.Data["Employee"][0].IsForcePasswordChange,
                // HiredDate: json.Data["Employee"][0].HiredDate ? moment(json.Data["Employee"][0].HiredDate).toDate() : moment().toDate(),
                // TerminationDate: json.Data["Employee"][0].TerminationDate ? moment(json.Data["Employee"][0].TerminationDate).toDate() : null,
                // BillingRateStartDate: json.Data["Employee"][0].BillingRateStartDate ? moment(json.Data["Employee"][0].TerminationDate).toDate() : moment().toDate(),
                // BillingRateEndDate: json.Data["Employee"][0].BillingRateEndDate ? moment(json.Data["Employee"][0].BillingRateEndDate).toDate() : moment().toDate(),
                // HiredDate: json.Data["Employee"][0].HiredDate ? dateFormatByAccountCulture(json.Data["Employee"][0].HiredDate, cultureInfoName.toString()) : new Date(),
                HiredDate: json.Data["Employee"][0].HiredDate ? dateFormatByAccountCulture(moment.parseZone(json.Data["Employee"][0].HiredDate).format("YYYY-MM-DD"), cultureInfoName.toString()) : new Date(),
                TerminationDate: json.Data["Employee"][0].TerminationDate ? dateFormatByAccountCulture(json.Data["Employee"][0].TerminationDate, cultureInfoName.toString()) : null,
                BillingRateStartDate: json.Data["Employee"][0].BillingRateStartDate ? dateFormatByAccountCulture(json.Data["Employee"][0].BillingRateStartDate, cultureInfoName.toString()) : new Date(),
                BillingRateEndDate: json.Data["Employee"][0].BillingRateEndDate ? dateFormatByAccountCulture(json.Data["Employee"][0].BillingRateEndDate, cultureInfoName.toString()) : new Date(),
                isCanvasLoader: false,
                AllowAttendanceFromWebApp: json?.Data["Employee"][0]?.AllowAttendanceFromWebApp || false,
                AttendancePolicyName: json?.Data["Employee"][0]?.AttendancePolicyName || 'None',
                biometricUserId: json?.Data["Employee"][0]?.BiometricUserId,
                IsTimesheetAutoApproval: json?.Data["Employee"][0]?.IsTimesheetAutoApproval || false,
            });
            // setSelectedGeofenceProfile(json.Data["Employee"][0].AccountGeoFenceProfileId ?? geofenceProfileOptions[0]?.value);
            const geoFenceId = json.Data["Employee"][0].AccountGeoFenceProfileId;
            setSelectedGeofenceProfile(geoFenceId !== null && geoFenceId !== undefined ? geoFenceId : 0);
            let EmployeeManagerId = 0;
            EmployeeManagerId = json.Data["Employee"][0].EmployeeManagerId !== null ? json.Data["Employee"][0].EmployeeManagerId : 0
            if (EmployeeManagerId > 0) {
                employeeManagerEdit(EmployeeManagerId);
            } else {
                setSelectedEmployee({ value: 0, label: 'None' });
            }
            const oldId = json.Data["Employee"][0].AccountTimeOffPolicyId !== null ? json.Data["Employee"][0].AccountTimeOffPolicyId : json.Data["Active Employee Time Off Policy"][0].value;
            setPreviousTimeOffPolicyId(oldId);
        }

    }

    const getDefaultValOfSpecificCustomField = (customField: string, customFields: any) => {
        let foundItem = customFields.find((item: any) => item.DatabaseFieldName === customField);
        if (foundItem) {
            // return foundItem.MasterCustomDataTypeName === 'Date' ? moment().format(CurrentCultureDateFormat.toUpperCase()) : (foundItem.DefaultValue || '');
            // return foundItem.MasterCustomDataTypeName === 'Date' ? dateFormatByCulture(new Date(), CurrentCultureDateFormat) : (foundItem.DefaultValue || '');
            // return foundItem.MasterCustomDataTypeName === 'Date' ? new Date() : (foundItem.DefaultValue || '');
            return foundItem.MasterCustomDataTypeName === 'Date' ? moment(new Date()).format(customFieldInsertionFormat) : (foundItem.DefaultValue || '');
        } else {
            return '';
        }
    }

    const setCustomFieldValues = (customField: string, customFieldData: any, customFields: any) => {
        let foundItem = customFields.find((item: any) => item.DatabaseFieldName === customField);

        // Safety check if field definition is not found
        if (!foundItem) return customFieldData;

        if (foundItem.MasterCustomDataTypeName === 'Date') {
            return customFieldData;
        }
        else if (foundItem.MasterCustomDataTypeName === 'Number') {
            if (customFieldData !== null && customFieldData !== undefined && customFieldData !== '') {
                return formatNumberCustomoriginalapiv2(cultureInfoName.toString(), customFieldData, decimalPlaces);
            }
            return customFieldData;
        }
        else {
            return customFieldData;
        }
    }

    const employeeManagerEdit = async (EmployeeManagerId: any) => {
        let found = false;
        let currentPage = 1;
        setLoading(true);
        setData([]);
        let isFirstPage = true;
        while (!found && hasMore) {
            try {
                const response: any = await fetchAPI(`api/V2/Employees/CurrentActiveNameAndIdForDropdown/${EmployeeManagerId}?page=${currentPage}&search=${""}`, "GET", "", true);
                const json = await response.json();
                const transformedData = json.items.map((item: any) => ({
                    value: item.id,
                    label: item.text,
                }));
                if (isFirstPage) {
                    const noneOption = { value: 0, label: 'None' };
                    setData([noneOption, ...transformedData]);
                    isFirstPage = false;
                } else {
                    setData((prevData) => [...prevData, ...transformedData]);
                }
                setHasMore(transformedData.length > 0);
                const targetItem = transformedData.find((item: any) => item.value === EmployeeManagerId);
                if (targetItem) {
                    setSelectedEmployee(targetItem);
                    found = true;
                } else {
                    currentPage += 1;
                }
            } catch (error) {
                Sentry.captureException(error);
                break;
            } finally {
                setLoading(false);
            }
        }
    }

    const onDateChange = (date: any, name: any) => {
        setemployeeValues({
            ...employeeValues,
            BillingRateStartDate: name == "BillingRateStartDate" ? date : employeeValues.BillingRateStartDate,
            BillingRateEndDate: name == "BillingRateEndDate" ? date : employeeValues.BillingRateEndDate,
            HiredDate: name == "HiredDate" ? date : employeeValues.HiredDate,
            TerminationDate: name == "TerminationDate" ? date : employeeValues.TerminationDate,
        });
    }

    const handleCloseOnClickEvent = () => {
        dispatch(resetSelectedRecordObjectInState());
    }

    const handleRegeneratePin = () => {
        const newPin = generateNewPin();
        setemployeeValues({
            ...employeeValues,
            pinCode: newPin
        });
    }

    const generateNewPin = () => {
        const newPin = Math.floor(100000 + Math.random() * 900000).toString();
        return newPin;
    }

    const handleColorChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newColor = event.target.value;
        setemployeeValues({
            ...employeeValues,
            ProfilePictureColor: newColor
        });
    }

    const onSwitch = (data: any) => {
        let switchName = data.target.name;
        // const { IsDisabled } = employeeValues;
        setemployeeValues({
            ...employeeValues,
            IsShowEmployeeProfilePicture: switchName == "IsShowEmployeeProfilePicture" ? employeeValues.IsShowEmployeeProfilePicture ? false : true : employeeValues.IsShowEmployeeProfilePicture,
            IsTimeInOutAvailable: switchName == "IsTimeInOutAvailable" ? employeeValues.IsTimeInOutAvailable ? false : true : employeeValues.IsTimeInOutAvailable,
            IsForcePasswordChange: switchName == "IsForcePasswordChange" ? employeeValues.IsForcePasswordChange ? false : true : employeeValues.IsForcePasswordChange,
            IsDisabled: switchName == "IsDisabled" ? employeeValues.IsDisabled ? false : true : employeeValues.IsDisabled,
            AllowAttendanceFromWebApp: switchName === 'AllowAttendanceFromWebApp' ? employeeValues?.AllowAttendanceFromWebApp ? false : true : employeeValues?.AllowAttendanceFromWebApp,
            IsTimesheetAutoApproval: switchName === 'IsTimesheetAutoApproval' ? employeeValues?.IsTimesheetAutoApproval ? false : true : employeeValues?.IsTimesheetAutoApproval
        });
    }

    const getFormattedCustomField = (fieldName: string, value: any) => {
        const field = customFieldsArray.find((item: any) => item.DatabaseFieldName === fieldName);
        // If field exists, is type Number, and has a value
        if (field && field.MasterCustomDataTypeName === 'Number' && value) {
            return value.toString().replace(',', '.');
        }
        return value;
    };

    const handleAddUpdateToRedux = async (validateValue: any) => {

        const approvalTypeObj = employeeResponse.TimeOffApprovalType.find((x: any) => x.value == employeeValues.AccountApprovalTypeId);
        const approvalTypeName = approvalTypeObj?.label;
        const employeeManagerValue = selectedEmployee?.value || employeeValues.EmployeeManagerId;
        if (approvalTypeName === "Employee Manager") {
            if (!employeeManagerValue || employeeManagerValue === "0" || employeeManagerValue === "none") {
                ShowSwalForCanvas('Warning', 'Please select a valid Employee Manager before proceeding.', 'warning');
                return;
            }
        }
        if (isEmailUnique) {
        } else {
        }
        if (accountemployeeid == 0) {

            // Normalize numeric values before creating object
            const normalizedEmployeeRateValue = parseLocalizedNumber(employeeRateValue);
            const normalizedbillingRateValue = parseLocalizedNumber(billingRateValue);
            console.log("handleAddUpdateToRedux", validateValue.CustomField1)
            //const normalizedestimatedCost = parseLocalizedNumber(estimatedCost);
            let object = {
                EmailAddress: validateValue.emailAddress,
                EmployeeCode: employeeValues.EmployeeCode,
                FirstName: validateValue.firstName,
                MiddleName: employeeValues.MiddleName,
                LastName: validateValue.lastName,
                Password: validateValue.password,
                //AccountRoleId: employeeValues.AccountRoleId,
                AccountRoleId: validateValue.AccountRoleId,
                //AccountDepartmentId: employeeValues.AccountDepartmentId,
                AccountDepartmentId: validateValue.AccountDepartmentId,
                //AccountLocationId: employeeValues.AccountLocationId,
                AccountLocationId: validateValue.AccountLocationId,
                AddressLine1: employeeValues.AddressLine1,
                AddressLine2: employeeValues.AddressLine2,
                City: employeeValues.City,
                State: employeeValues.State,
                //CountryId: employeeValues.CountryId,
                CountryId: validateValue.CountryId,
                Zip: employeeValues.Zip,
                HomePhoneNo: employeeValues.HomePhoneNo,
                WorkPhoneNo: employeeValues.WorkPhoneNo,
                MobilePhoneNo: employeeValues.MobilePhoneNo,
                //AccountWorkTypeId: employeeValues.AccountWorkTypeId,
                AccountWorkTypeId: validateValue.AccountWorkTypeId,
                //AccountBillingTypeId: employeeValues.AccountBillingTypeId,
                AccountBillingTypeId: validateValue.AccountBillingTypeId,
                // EmployeeRate: employeeValues.EmployeeRate,
                EmployeeRate: normalizedEmployeeRateValue,
                //EmployeeRateCurrencyId: employeeValues.EmployeeRateCurrencyId,
                EmployeeRateCurrencyId: validateValue.EmployeeRateCurrencyId,
                //BillingRateCurrencyId: employeeValues.BillingRateCurrencyId,
                BillingRateCurrencyId: validateValue.BillingRateCurrencyId,
                // BillingRate: employeeValues.BillingRate,
                BillingRate: normalizedbillingRateValue,
                //AccountWorkingDayTypeId: employeeValues.AccountWorkingDayTypeId,
                AccountWorkingDayTypeId: validateValue.AccountWorkingDayTypeId,
                //StatusId: employeeValues.AccountStatusId,
                StatusId: validateValue.AccountStatusId,
                AccountTimeOffPolicyId: employeeValues.AccountTimeOffPolicyId,
                AccountApprovalTypeId: employeeValues.AccountApprovalTypeId,
                //AccountApprovalTypeId: validateValue.AccountApprovalTypeId,
                // EmployeeManagerId: employeeValues.EmployeeManagerId,
                EmployeeManagerId: selectedEmployee?.value,
                AccountHolidayTypeId: employeeValues.AccountHolidayTypeId,
                //TimeZoneId: employeeValues.TimeZoneId,
                TimeZoneId: validateValue.TimeZoneId,
                //EmployeePayTypeId: employeeValues.AccountEmployeeTypeId,
                EmployeePayTypeId: validateValue.AccountEmployeeTypeId,
                AccountShiftId: employeeValues.AccountShiftId,
                AccountExpensePolicyId: employeeValues.AccountExpensePolicyId,
                // BillingRateStartDate: employeeValues.BillingRateStartDate,
                // BillingRateEndDate: employeeValues.BillingRateEndDate,
                BillingRateStartDate: moment(employeeValues.BillingRateStartDate).format(dateInsertionFormat),
                BillingRateEndDate: moment(employeeValues.BillingRateEndDate).format(dateInsertionFormat),
                HiredDate: moment(employeeValues.HiredDate).format(dateInsertionFormat),//employeeValues.HiredDate,
                TerminationDate: employeeValues.TerminationDate !== null ? moment(employeeValues.TerminationDate).format(dateInsertionFormat) : null,//employeeValues.TerminationDate,
                //UserInterfaceLanguage: employeeValues.UserInterfaceLanguageId,
                UserInterfaceLanguage: validateValue.UserInterfaceLanguageId,
                EmployeePin: employeeValues.pinCode,
                JobTitle: employeeValues.JobTitle,
                IsShowEmployeeProfilePicture: employeeValues.IsShowEmployeeProfilePicture,
                IsTimeInOutAvailable: employeeValues.IsTimeInOutAvailable,
                IsForcePasswordChange: employeeValues.IsForcePasswordChange,
                ProfilePictureColor: employeeValues.ProfilePictureColor,
                AccountGeoFenceProfileId: selectedGeofenceprofile,
                AllowAttendanceFromWebApp: employeeValues?.AllowAttendanceFromWebApp,
                // BiometricUserId: employeeValues?.biometricUserId ?? null,
                BiometricUserId: employeeValues?.biometricUserId != null && String(employeeValues.biometricUserId).trim() !== '' ? String(employeeValues.biometricUserId).trim() : null,
                IsTimesheetAutoApproval: employeeValues.IsTimesheetAutoApproval,
                CustomField1: getFormattedCustomField('CustomField1', validateValue.CustomField1),
                CustomField2: getFormattedCustomField('CustomField2', validateValue.CustomField2),
                CustomField3: getFormattedCustomField('CustomField3', validateValue.CustomField3),
                CustomField4: getFormattedCustomField('CustomField4', validateValue.CustomField4),
                CustomField5: getFormattedCustomField('CustomField5', validateValue.CustomField5),
                CustomField6: getFormattedCustomField('CustomField6', validateValue.CustomField6),
                CustomField7: getFormattedCustomField('CustomField7', validateValue.CustomField7),
                CustomField8: getFormattedCustomField('CustomField8', validateValue.CustomField8),
                CustomField9: getFormattedCustomField('CustomField9', validateValue.CustomField9),
                CustomField10: getFormattedCustomField('CustomField10', validateValue.CustomField10),
                CustomField11: getFormattedCustomField('CustomField11', validateValue.CustomField11),
                CustomField12: getFormattedCustomField('CustomField12', validateValue.CustomField12),
                CustomField13: getFormattedCustomField('CustomField13', validateValue.CustomField13),
                CustomField14: getFormattedCustomField('CustomField14', validateValue.CustomField14),
                CustomField15: getFormattedCustomField('CustomField15', validateValue.CustomField15)
            }

            dispatch(addAccountEmployeeAsync(object)).then((result) => {
                if (result.payload.StatusCode == '500') {
                    ShowToast('Error', result.payload.ResponseMessage, "error", "toast-top-right");
                }
                const success = Number(result.payload.Data[0].AccountEmployeeId) > 0;
                ShowToast(success ? 'Success' : 'error', result.payload.ResponseMessage, success ? "success" : "error", "toast-top-right");
                if (success) {
                    if (closeButtonRef.current) {
                        closeButtonRef.current.click();
                    }
                    dispatch(updateAccountEmployeeId(result.payload.Data[0].AccountEmployeeId));
                    // navigate('/employeesummary', {
                    //     state: {
                    //         "AccountEmployeeId": result.payload.Data[0].AccountEmployeeId,
                    //         "IsSummaryFrom": 'Task'
                    //     }
                    // });
                    navigateToEmployeeSummary({ "AccountEmployeeId": result.payload.Data[0].AccountEmployeeId, "IsSummaryFrom": 'Task' });
                }
            }).catch((error) => {
                Sentry.captureException(error);
                ShowToast('error', 'An error occurred while processing your request', "error", "toast-top-right");
            }).finally(() => {
            });
        }
        else {
            // Normalize numeric values before creating object
            const normalizedEmployeeRateValue = parseLocalizedNumber(employeeRateValue);
            const normalizedbillingRateValue = parseLocalizedNumber(billingRateValue);
            let object = {
                EmailAddress: validateValue.emailAddress,
                EmployeeCode: employeeValues.EmployeeCode,
                FirstName: validateValue.firstName,
                MiddleName: employeeValues.MiddleName,
                LastName: validateValue.lastName,
                Password: validateValue.password,
                //AccountRoleId: employeeValues.AccountRoleId,
                AccountRoleId: validateValue.AccountRoleId,
                //AccountDepartmentId: employeeValues.AccountDepartmentId,
                AccountDepartmentId: validateValue.AccountDepartmentId,
                //AccountLocationId: employeeValues.AccountLocationId,
                AccountLocationId: validateValue.AccountLocationId,
                AddressLine1: employeeValues.AddressLine1,
                AddressLine2: employeeValues.AddressLine2,
                City: employeeValues.City,
                State: employeeValues.State,
                //CountryId: employeeValues.CountryId,
                CountryId: validateValue.CountryId,
                Zip: employeeValues.Zip,
                HomePhoneNo: employeeValues.HomePhoneNo,
                WorkPhoneNo: employeeValues.WorkPhoneNo,
                MobilePhoneNo: employeeValues.MobilePhoneNo,
                //AccountWorkTypeId: employeeValues.AccountWorkTypeId,
                AccountWorkTypeId: validateValue.AccountWorkTypeId,
                //AccountBillingTypeId: employeeValues.AccountBillingTypeId,
                AccountBillingTypeId: validateValue.AccountBillingTypeId,
                // EmployeeRate: employeeValues.EmployeeRate,
                EmployeeRate: normalizedEmployeeRateValue,
                //EmployeeRateCurrencyId: employeeValues.EmployeeRateCurrencyId,
                EmployeeRateCurrencyId: validateValue.EmployeeRateCurrencyId,
                //BillingRateCurrencyId: employeeValues.BillingRateCurrencyId,
                BillingRateCurrencyId: validateValue.BillingRateCurrencyId,
                // BillingRate: employeeValues.BillingRate,
                BillingRate: normalizedbillingRateValue,
                //AccountWorkingDayTypeId: employeeValues.AccountWorkingDayTypeId,
                AccountWorkingDayTypeId: validateValue.AccountWorkingDayTypeId,
                //StatusId: employeeValues.AccountStatusId,
                StatusId: validateValue.AccountStatusId,
                AccountTimeOffPolicyId: employeeValues.AccountTimeOffPolicyId,
                AccountApprovalTypeId: employeeValues.AccountApprovalTypeId,
                //AccountApprovalTypeId: validateValue.AccountApprovalTypeId,
                EmployeeManagerId: selectedEmployee?.value,
                // EmployeeManagerId: employeeValues.EmployeeManagerId,
                AccountHolidayTypeId: employeeValues.AccountHolidayTypeId,
                //TimeZoneId: employeeValues.TimeZoneId,
                TimeZoneId: validateValue.TimeZoneId,
                //EmployeePayTypeId: employeeValues.AccountEmployeeTypeId,
                EmployeePayTypeId: validateValue.AccountEmployeeTypeId,
                AccountShiftId: employeeValues.AccountShiftId,
                AccountExpensePolicyId: employeeValues.AccountExpensePolicyId,
                // BillingRateStartDate: employeeValues.BillingRateStartDate,
                // BillingRateEndDate: employeeValues.BillingRateEndDate,
                BillingRateStartDate: moment(employeeValues.BillingRateStartDate).format(dateInsertionFormat),
                BillingRateEndDate: moment(employeeValues.BillingRateEndDate).format(dateInsertionFormat),
                HiredDate: moment(employeeValues.HiredDate).format(dateInsertionFormat),//employeeValues.HiredDate,
                TerminationDate: employeeValues.TerminationDate !== null ? moment(employeeValues.TerminationDate).format(dateInsertionFormat) : null,//employeeValues.TerminationDate,
                AccountEmployeeId: employeeValues.AccountEmployeeId,
                //UserInterfaceLanguage: employeeValues.UserInterfaceLanguageId,
                UserInterfaceLanguage: validateValue.UserInterfaceLanguageId,
                EmployeePin: employeeValues.pinCode,
                JobTitle: employeeValues.JobTitle,
                IsDisabled: employeeValues.IsDisabled,
                IsShowEmployeeProfilePicture: employeeValues.IsShowEmployeeProfilePicture,
                IsTimeInOutAvailable: employeeValues.IsTimeInOutAvailable,
                IsForcePasswordChange: employeeValues.IsForcePasswordChange,
                ProfilePictureColor: employeeValues.ProfilePictureColor,
                AccountGeoFenceProfileId: selectedGeofenceprofile,
                AllowAttendanceFromWebApp: employeeValues?.AllowAttendanceFromWebApp,
                // BiometricUserId: employeeValues?.biometricUserId ?? null,
                BiometricUserId: employeeValues?.biometricUserId != null && String(employeeValues.biometricUserId).trim() !== '' ? String(employeeValues.biometricUserId).trim() : null,
                IsTimesheetAutoApproval: employeeValues.IsTimesheetAutoApproval,
                CustomField1: getFormattedCustomField('CustomField1', validateValue.CustomField1),
                CustomField2: getFormattedCustomField('CustomField2', validateValue.CustomField2),
                CustomField3: getFormattedCustomField('CustomField3', validateValue.CustomField3),
                CustomField4: getFormattedCustomField('CustomField4', validateValue.CustomField4),
                CustomField5: getFormattedCustomField('CustomField5', validateValue.CustomField5),
                CustomField6: getFormattedCustomField('CustomField6', validateValue.CustomField6),
                CustomField7: getFormattedCustomField('CustomField7', validateValue.CustomField7),
                CustomField8: getFormattedCustomField('CustomField8', validateValue.CustomField8),
                CustomField9: getFormattedCustomField('CustomField9', validateValue.CustomField9),
                CustomField10: getFormattedCustomField('CustomField10', validateValue.CustomField10),
                CustomField11: getFormattedCustomField('CustomField11', validateValue.CustomField11),
                CustomField12: getFormattedCustomField('CustomField12', validateValue.CustomField12),
                CustomField13: getFormattedCustomField('CustomField13', validateValue.CustomField13),
                CustomField14: getFormattedCustomField('CustomField14', validateValue.CustomField14),
                CustomField15: getFormattedCustomField('CustomField15', validateValue.CustomField15)
            }
            const oldPolicy = previousTimeOffPolicyId;
            const newPolicy = object.AccountTimeOffPolicyId;

            if (oldPolicy !== newPolicy) {
                const confirmed = await ShowSwalWithConfirmation(
                    "Warning",
                    "Changing TimeOff Policy will reset all consumed Leave records. Available leave balance will be recalculated according to the new policy.",
                    "Proceed", "custom-swal-container"
                );
                if (!confirmed) {
                    object.AccountTimeOffPolicyId = oldPolicy;
                }
            }
            console.log('object',object)
            dispatch(updateAccountEmployeeAsync(object)).then((result) => {
                const success = Number(result.payload.Data[0].AccountEmployeeId) > 0;
                ShowToast(success ? 'Success' : 'error', result.payload.ResponseMessage, success ? "success" : "error", "toast-top-right");
                if (success) {
                    if (closeButtonRef.current) {
                        closeButtonRef.current.click();
                    }
                }
            }).catch((error) => {
                Sentry.captureException(error);
                ShowToast('error', 'An error occurred while processing your request', "error", "toast-top-right");
            }).finally(() => {
            });
        }
    }

    const handleChangeOption = (selected: any) => {
        setSelectedEmployee(selected);
    }

    const handleInputChange = (inputValue: string) => {
        setSearch(inputValue);
        setIsSearch(true);
    }

    // Assuming this is your initial schema setup
    const validationSchema = yup.object().shape(
        // Remove ClientName validation
        (
            enablePasswordComplexity
                ? {
                    // emailAddress: yup
                    // .string()
                    // .email(getValueFromResource('Invalid email', dispatch, t))
                    // .required(getValueFromResource('Email is required', dispatch, t)),
                    emailAddress: yup.string()
                        .matches(
                            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                            'Invalid email format'
                        )
                        .required('Email is required'),
                    firstName: yup
                        .string()
                        .label('First Name')
                        .required(getValueFromResource('First Name is required', dispatch, t)),
                    lastName: yup
                        .string()
                        .label('Last Name')
                        .required(getValueFromResource('Last Name is required', dispatch, t)),
                    password: accountemployeeid
                        ? yup
                            .string()
                            .min(6, getValueFromResource('Password must be at least 6 characters', dispatch, t))
                            .matches(
                                /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+\-.,])[A-Za-z\d~!@#$%^&*()_+\-.,]+$/,
                                getValueFromResource(
                                    'Password must contain at least one uppercase, lowercase, numeric, and special character',
                                    dispatch,
                                    t
                                )
                            )
                            .test(
                                'password-required-if-verify',
                                getValueFromResource('Password is required', dispatch, t),
                                function (value) {
                                    const { verifyPassword } = this.parent;
                                    if (verifyPassword && !value) return false;
                                    return true;
                                }
                            )
                        : yup
                            .string()
                            .min(6, getValueFromResource('Password must be at least 6 characters', dispatch, t))
                            .matches(
                                /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+\-.,])[A-Za-z\d~!@#$%^&*()_+\-.,]+$/,
                                getValueFromResource(
                                    'Password must contain at least one uppercase, lowercase, numeric, and special character',
                                    dispatch,
                                    t
                                )
                            )
                            .required(getValueFromResource('Password is required', dispatch, t)),

                    verifyPassword: accountemployeeid
                        ? yup
                            .string()
                            .min(6, getValueFromResource('Password must be at least 6 characters', dispatch, t))
                            .oneOf([yup.ref('password')], getValueFromResource('Passwords do not match', dispatch, t))
                            .test(
                                'verify-required-if-password',
                                getValueFromResource('Password verification is required', dispatch, t),
                                function (value) {
                                    const { password } = this.parent;
                                    if (password && !value) return false;
                                    return true;
                                }
                            )
                        : yup
                            .string()
                            .min(6, getValueFromResource('Password must be at least 6 characters', dispatch, t))
                            .oneOf([yup.ref('password')], getValueFromResource('Passwords do not match', dispatch, t))
                            .required(getValueFromResource('Password verification is required', dispatch, t)),


                    AccountRoleId: yup
                        .string()
                        .required(getValueFromResource('Role is required', dispatch, t))
                        .test('not-zero', getValueFromResource('Role is required', dispatch, t), value => value !== '0'),
                    AccountDepartmentId: yup
                        .string()
                        .required(getValueFromResource('Department is required', dispatch, t))
                        .test('not-zero', getValueFromResource('Department is required', dispatch, t), value => value !== '0'),
                    AccountLocationId: yup
                        .string()
                        .required(getValueFromResource('Location is required', dispatch, t))
                        .test('not-zero', getValueFromResource('Location is required', dispatch, t), value => value !== '0'),
                    AccountWorkTypeId: yup
                        .string()
                        .required(getValueFromResource('Work Type is required', dispatch, t))
                        .test('not-zero', getValueFromResource('Work Type is required', dispatch, t), value => value !== '0'),
                    EmployeeRateCurrencyId: yup
                        .string()
                        .required(getValueFromResource('Employee Rate Currency is required', dispatch, t))
                        .test('not-zero', getValueFromResource('Employee Rate Currency is required', dispatch, t), value => value !== '0'),
                    BillingRateCurrencyId: yup
                        .string()
                        .required(getValueFromResource('Billing Rate Currency is required', dispatch, t))
                        .test('not-zero', getValueFromResource('Billing Rate Currency is required', dispatch, t), value => value !== '0'),
                    AccountWorkingDayTypeId: yup
                        .string()
                        .required(getValueFromResource('Working Day Type is required', dispatch, t))
                        .test('not-zero', getValueFromResource('Working Day Type is required', dispatch, t), value => value !== '0'),
                    AccountStatusId: yup
                        .string()
                        .required(getValueFromResource('Status is required', dispatch, t))
                        .test('not-zero', getValueFromResource('Status is required', dispatch, t), value => value !== '0'),
                    AccountEmployeeTypeId: yup
                        .string()
                        .required(getValueFromResource('Employee Type is required', dispatch, t))
                        .test('not-zero', getValueFromResource('Employee Type is required', dispatch, t), value => value !== '0'),
                    UserInterfaceLanguageId: yup
                        .string()
                        .required(getValueFromResource('User Interface Language is required', dispatch, t))
                        .test('not-zero', getValueFromResource('User Interface Language is required', dispatch, t), value => value !== ''),
                    CountryId: yup
                        .string()
                        .required(getValueFromResource('Country is required', dispatch, t))
                        .test('not-zero', getValueFromResource('Country is required', dispatch, t), value => value !== '0'),
                    AccountBillingTypeId: yup
                        .string()
                        .required(getValueFromResource('Billing Type is required', dispatch, t))
                        .test('not-zero', getValueFromResource('Billing Type is required', dispatch, t), value => value !== '0'),
                    TimeZoneId: yup
                        .string()
                        .required(getValueFromResource('Time Zone is required', dispatch, t))
                        .test('not-zero', getValueFromResource('Time Zone is required', dispatch, t), value => value !== '0'),
                    ...Object.fromEntries(
                        customFieldsArray
                            .filter((x: any) => !x.IsDisabled)
                            .map((x: any) => {
                                let yupSchema;

                                if (x.MasterCustomDataTypeName === 'Number') {
                                    yupSchema = yup
                                        .string()
                                        .test(
                                            'culture-format-check',
                                            () => {
                                                const isComma = determineCommaSeprater(cultureInfoName.toString());
                                                return isComma
                                                    ? `${x.CustomFieldCaption} allows only numbers and comma (,)`
                                                    : `${x.CustomFieldCaption} allows only numbers and dot (.)`;
                                            },
                                            (value) => {
                                                if (!value) return true;

                                                const isComma = determineCommaSeprater(cultureInfoName.toString());

                                                return isComma
                                                    ? /^\d+(,\d+)?$/.test(value)
                                                    : /^\d+(\.\d+)?$/.test(value);
                                            }
                                        )

                                        // Minimum value check
                                        .test(
                                            'min-value',
                                            `${x.CustomFieldCaption} must be at least ${x.MinimumValue}`,
                                            (value) => {
                                                if (!value || x.MinimumValue == null) return true;

                                                const isComma = determineCommaSeprater(cultureInfoName.toString());
                                                const normalizedValue = isComma
                                                    ? value.replace(',', '.')
                                                    : value;

                                                const numberValue = parseFloat(normalizedValue);
                                                return !isNaN(numberValue) && numberValue >= x.MinimumValue;
                                            }
                                        )

                                        // Maximum value check
                                        .test(
                                            'max-value',
                                            `${x.CustomFieldCaption} must be at most ${x.MaximumValue}`,
                                            (value) => {
                                                if (!value || x.MaximumValue == null) return true;

                                                const isComma = determineCommaSeprater(cultureInfoName.toString());
                                                const normalizedValue = isComma
                                                    ? value.replace(',', '.')
                                                    : value;

                                                const numberValue = parseFloat(normalizedValue);
                                                return !isNaN(numberValue) && numberValue <= x.MaximumValue;
                                            }
                                        );
                                }
                                else if (x.MasterCustomDataTypeName === 'Text') {
                                    // Assuming it's a text field
                                    yupSchema = yup.string().trim();
                                    if (x.MaximumLength != null) {
                                        yupSchema = yupSchema.max(x.MaximumLength, `${x.CustomFieldCaption} must be at most ${x.MaximumLength} characters`);
                                    }
                                }
                                else if (x.MasterCustomDataTypeName === 'Date') {
                                    yupSchema = yup.date()
                                        .nullable()
                                        //.required(`${x.CustomFieldCaption} is required`)
                                        .typeError(`Please enter a valid ${x.CustomFieldCaption}`)
                                        .min(new Date('1900-01-01'), `${x.CustomFieldCaption} must be after 01/01/1900`)
                                    // .max(new Date(), `${x.CustomFieldCaption} must be on or before today`);
                                }
                                if (x.IsRequired) {
                                    yupSchema = yupSchema?.required(`${x.CustomFieldCaption} is required`);
                                }
                                // if (x.MasterCustomDataTypeName === 'Number' || x.MasterCustomDataTypeName === 'Text' || x.MasterCustomDataTypeName === 'Drop-Down') {
                                //     if (x.IsRequired ) {
                                //         yupSchema = yupSchema?.required(`${x.CustomFieldCaption} is required`);
                                //     }
                                // }
                                // else {
                                // }
                                return [x.DatabaseFieldName, yupSchema];
                            })
                    ),
                }
                : {
                    // emailAddress: yup
                    // .string()
                    // .email(getValueFromResource('Invalid email', dispatch, t))
                    // .required(getValueFromResource('Email is required', dispatch, t)),
                    emailAddress: yup.string()
                        .matches(
                            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                            'Invalid email format'
                        )
                        .required('Email is required'),
                    firstName: yup
                        .string()
                        .label('First Name')
                        .required(getValueFromResource('First Name is required', dispatch, t)),
                    lastName: yup
                        .string()
                        .label('Last Name')
                        .required(getValueFromResource('Last Name is required', dispatch, t)),
                    // password: accountemployeeid
                    //     ? yup.string()
                    //     : yup.string().required(getValueFromResource('Password is required', dispatch, t)),
                    // verifyPassword: accountemployeeid
                    //     ? yup
                    //         .string()
                    //         .oneOf([yup.ref('password')], getValueFromResource('Passwords do not match', dispatch, t))
                    //         .nullable()
                    //     : yup
                    //         .string()
                    //         .oneOf([yup.ref('password')], getValueFromResource('Passwords do not match', dispatch, t))
                    //         .nullable()
                    //         .required(getValueFromResource('Password verification is required', dispatch, t)),
                    password: accountemployeeid
                        ? yup.string().test(
                            "password-required-if-verify",
                            getValueFromResource("Password is required", dispatch, t),
                            function (value) {
                                const { verifyPassword } = this.parent;
                                if (verifyPassword && !value) {
                                    return false;
                                }
                                return true;
                            }
                        )
                        : yup
                            .string()
                            .required(getValueFromResource("Password is required", dispatch, t)),

                    verifyPassword: accountemployeeid
                        ? yup.string().when("password", (password, schema) => {
                            if (password[0] != undefined) {
                                return schema
                                    .required(
                                        getValueFromResource("Password verification is required", dispatch, t)
                                    )
                                    .oneOf(
                                        [yup.ref("password")],
                                        getValueFromResource("Passwords do not match", dispatch, t)
                                    );
                            }
                            return schema;
                        })
                        : yup
                            .string()
                            .required(
                                getValueFromResource("Password verification is required", dispatch, t)
                            )
                            .oneOf(
                                [yup.ref("password")],
                                getValueFromResource("Passwords do not match", dispatch, t)
                            ),

                    AccountRoleId: yup
                        .string()
                        .required(getValueFromResource('Role is required', dispatch, t))
                        .test('not-zero', getValueFromResource('Role is required', dispatch, t), value => value !== '0'),
                    AccountDepartmentId: yup
                        .string()
                        .required(getValueFromResource('Department is required', dispatch, t))
                        .test('not-zero', getValueFromResource('Department is required', dispatch, t), value => value !== '0'),
                    AccountLocationId: yup
                        .string()
                        .required(getValueFromResource('Location is required', dispatch, t))
                        .test('not-zero', getValueFromResource('Location is required', dispatch, t), value => value !== '0'),
                    AccountWorkTypeId: yup
                        .string()
                        .required(getValueFromResource('Work Type is required', dispatch, t))
                        .test('not-zero', getValueFromResource('Work Type is required', dispatch, t), value => value !== '0'),
                    EmployeeRateCurrencyId: yup
                        .string()
                        .required(getValueFromResource('Employee Rate Currency is required', dispatch, t))
                        .test('not-zero', getValueFromResource('Employee Rate Currency is required', dispatch, t), value => value !== '0'),
                    BillingRateCurrencyId: yup
                        .string()
                        .required(getValueFromResource('Billing Rate Currency is required', dispatch, t))
                        .test('not-zero', getValueFromResource('Billing Rate Currency is required', dispatch, t), value => value !== '0'),
                    AccountWorkingDayTypeId: yup
                        .string()
                        .required(getValueFromResource('Working Day Type is required', dispatch, t))
                        .test('not-zero', getValueFromResource('Working Day Type is required', dispatch, t), value => value !== '0'),
                    AccountStatusId: yup
                        .string()
                        .required(getValueFromResource('Status is required', dispatch, t))
                        .test('not-zero', getValueFromResource('Status is required', dispatch, t), value => value !== '0'),
                    AccountEmployeeTypeId: yup
                        .string()
                        .required(getValueFromResource('Employee Type is required', dispatch, t))
                        .test('not-zero', getValueFromResource('Employee Type is required', dispatch, t), value => value !== '0'),
                    UserInterfaceLanguageId: yup
                        .string()
                        .required(getValueFromResource('User Interface Language is required', dispatch, t))
                        .test('not-zero', getValueFromResource('User Interface Language is required', dispatch, t), value => value !== '0'),
                    CountryId: yup
                        .string()
                        .required(getValueFromResource('Country is required', dispatch, t))
                        .test('not-zero', getValueFromResource('Country is required', dispatch, t), value => value !== '0'),
                    AccountBillingTypeId: yup
                        .string()
                        .required(getValueFromResource('Billing Type is required', dispatch, t))
                        .test('not-zero', getValueFromResource('Billing Type is required', dispatch, t), value => value !== '0'),
                    TimeZoneId: yup
                        .string()
                        .required(getValueFromResource('Time Zone is required', dispatch, t))
                        .test('not-zero', getValueFromResource('Time Zone is required', dispatch, t), value => value !== '0'),
                    ...Object.fromEntries(
                        customFieldsArray
                            .filter((x: any) => !x.IsDisabled)
                            .map((x: any) => {
                                let yupSchema;
                                if (x.MasterCustomDataTypeName === 'Number') {
                                    yupSchema = yup
                                        .string()
                                        .test(
                                            'culture-format-check',
                                            () => {
                                                const isComma = determineCommaSeprater(cultureInfoName.toString());
                                                return isComma
                                                    ? `${x.CustomFieldCaption} allows only numbers and comma (,)`
                                                    : `${x.CustomFieldCaption} allows only numbers and dot (.)`;
                                            },
                                            (value) => {
                                                if (!value) return true;

                                                const isComma = determineCommaSeprater(cultureInfoName.toString());

                                                return isComma
                                                    ? /^\d+(,\d+)?$/.test(value)
                                                    : /^\d+(\.\d+)?$/.test(value);
                                            }
                                        )

                                        // Minimum value check
                                        .test(
                                            'min-value',
                                            `${x.CustomFieldCaption} must be at least ${x.MinimumValue}`,
                                            (value) => {
                                                if (!value || x.MinimumValue == null) return true;

                                                const isComma = determineCommaSeprater(cultureInfoName.toString());
                                                const normalizedValue = isComma
                                                    ? value.replace(',', '.')
                                                    : value;

                                                const numberValue = parseFloat(normalizedValue);
                                                return !isNaN(numberValue) && numberValue >= x.MinimumValue;
                                            }
                                        )

                                        // Maximum value check
                                        .test(
                                            'max-value',
                                            `${x.CustomFieldCaption} must be at most ${x.MaximumValue}`,
                                            (value) => {
                                                if (!value || x.MaximumValue == null) return true;

                                                const isComma = determineCommaSeprater(cultureInfoName.toString());
                                                const normalizedValue = isComma
                                                    ? value.replace(',', '.')
                                                    : value;

                                                const numberValue = parseFloat(normalizedValue);
                                                return !isNaN(numberValue) && numberValue <= x.MaximumValue;
                                            }
                                        );
                                }
                                else if (x.MasterCustomDataTypeName === 'Text') {
                                    // Assuming it's a text field
                                    yupSchema = yup.string().trim();
                                    if (x.MaximumLength != null) {
                                        yupSchema = yupSchema.max(x.MaximumLength, `${x.CustomFieldCaption} must be at most ${x.MaximumLength} characters`);
                                    }
                                }
                                else if (x.MasterCustomDataTypeName === 'Date') {
                                    yupSchema = yup.date()
                                        .nullable()
                                        //.required(`${x.CustomFieldCaption} is required`)
                                        .typeError(`Please enter a valid ${x.CustomFieldCaption}`)
                                        .min(new Date('1900-01-01'), `${x.CustomFieldCaption} must be after 01/01/1900`)
                                    // .max(new Date(), `${x.CustomFieldCaption} must be on or before today`);
                                }
                                if (x.IsRequired) {
                                    yupSchema = yupSchema?.required(`${x.CustomFieldCaption} is required`);
                                }
                                // if (x.MasterCustomDataTypeName === 'Number' || x.MasterCustomDataTypeName === 'Text' || x.MasterCustomDataTypeName === 'Drop-Down') {
                                //     if (x.IsRequired && x.DefaultValue === '') {
                                //         yupSchema = yupSchema?.required(`${x.CustomFieldCaption} is required`);
                                //     }
                                // }
                                // else {
                                //     if (x.IsRequired) {
                                //         yupSchema = yupSchema?.required(`${x.CustomFieldCaption} is required`);
                                //     }
                                // }
                                return [x.DatabaseFieldName, yupSchema];
                            })
                    ),
                })
    );

    const handleBlurValidateAll = async (setFieldTouched: any, values: any, validateForm: any, e: any = null) => {
        if (e) {
            if (e.target) {
                const fieldName = e.target.name;
                const fieldValue = e.target.value;
                setEmailValidate(true)
                try {
                    if (fieldValue !== '') {
                        dispatch(GetEmailAddressValidationAsync({ EMailAddress: fieldValue, AccountEmployeeId: accountemployeeid === undefined ? 0 : accountemployeeid })).then((result) => {
                            setisEmailAvailabler(result.payload);
                            setFieldTouched("emailAddress", result.payload);
                            if (!result.payload) {
                                setEmailValidate(result.payload)
                                // ShowSwalForCanvas('Email Address', fieldValue + ' Email is already taken', 'warning');
                                return;
                            }
                        }).catch((error) => {
                            Sentry.captureException(error);
                        });
                    }
                } catch (error) {
                }
            }
        }
        // Mark all fields as touched
        //Object.keys(values).forEach(field => {
        // setFieldTouched(field, true);
        // });
        // Validate all fields
        // validateForm();
    }

    useEffect(() => {
        if (accountemployeeid == 0) {
            const formattedBillingRate = formatNumberCustomoriginalapiv2(
                cultureInfoName.toString(),
                0,
                decimalPlaces
            );
            const formattedEmployeeRate = formatNumberCustomoriginalapiv2(
                cultureInfoName.toString(),
                0,
                decimalPlaces
            );
            setBillingRateValue('');
            setEmployeeRateValue('');
        }
    }, [accountemployeeid])

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    }

    const toggleConfirmPasswordVisibility = () => {
        setShowConfirmPassword(!showConfirmPassword)
    }

    const handleDownloadQR = () => {
        const canvas = qrRef.current?.querySelector('canvas');
        if (canvas) {
            const link = document.createElement('a');
            link.download = `qr_${employeeValues.employeeYup?.firstName + ' ' + employeeValues?.employeeYup?.lastName || accountemployeeid}.png`;
            link.href = canvas.toDataURL('image/png');
            link.click();
        }
    };

    const qrPayload = JSON.stringify({
        AccountId: localStorage.getItem('accountId'),
        AccountEmployeeId: accountemployeeid,
        Username: employeeValues.employeeYup?.firstName + ' ' + employeeValues?.employeeYup?.lastName || ''
    });

    return (
        <>
            <Formik
                innerRef={formikRef}
                initialValues={employeeValues.employeeYup}
                enableReinitialize={true}
                onSubmit={values => handleAddUpdateToRedux(values)}
                validationSchema={validationSchema}
            // validationSchema={yup.object().shape(enablePasswordComplexity ? {
            //     password: accountemployeeid
            //         ? yup
            //             .string()
            //             .min(6, t('Password must be at least 6 characters'))
            //         : yup
            //             .string()
            //             .min(6, t('Password must be at least 6 characters'))
            //             .required(t('Password is required')),
            //     emailAddress: yup
            //         .string()
            //         .email(t('Invalid email'))
            //         .required(t('Email is required'))
            //         .test('unique-email', t('Email address is already taken'), async function (value) {
            //             try {
            //                 const response = await fetchAPI(`api/V2/Employees/EmailAddressValidation/${value}/` + accountemployeeid, 'Get', '', true, accessToken);
            //                 const data = await response.json();
            //                 if (data.ResponseMessage === "True") {
            //                     return true;
            //                 } else {
            //                     return false;
            //                 }
            //             } catch (error) {
            //                 return false;
            //             }
            //         }),
            //     firstName: yup
            //         .string()
            //         .label(t('First Name'))
            //         .required(),
            //     lastName: yup
            //         .string()
            //         .label(t('Last Name'))
            //         .required(),
            //     verifyPassword: accountemployeeid
            //         ? yup
            //             .string()
            //             .oneOf([yup.ref('password')], t('Passwords do not match'))
            //             .nullable()
            //         : yup
            //             .string()
            //             .oneOf([yup.ref('password')], t('Passwords do not match'))
            //             .nullable()
            //             .required(t('Password verification is required')),
            // } : {
            //     password: accountemployeeid
            //         ? yup
            //             .string()
            //         : yup
            //             .string()
            //             .required(t('Password is required')),
            //     emailAddress: yup
            //         .string()
            //         .email(t('Invalid email'))
            //         .required(t('Email is required'))
            //         .test('unique-email', t('Email address is already taken'), async function (value) {
            //             try {
            //                 const response = await fetchAPI(`api/V2/Employees/EmailAddressValidation/${value}/` + accountemployeeid, 'Get', '', true, accessToken);
            //                 const data = await response.json();
            //                 if (data.ResponseMessage === "True") {
            //                     return true;
            //                 } else {
            //                     return false;
            //                 }
            //             } catch (error) {
            //                 return false;
            //             }
            //         }),
            //     firstName: yup
            //         .string()
            //         .label(t('First Name'))
            //         .required(),
            //     lastName: yup
            //         .string()
            //         .label(t('Last Name'))
            //         .required(),
            //     verifyPassword: accountemployeeid
            //         ? yup
            //             .string()
            //             .oneOf([yup.ref('password')], t('Passwords do not match'))
            //             .nullable()
            //         : yup
            //             .string()
            //             .oneOf([yup.ref('password')], t('Passwords do not match'))
            //             .nullable()
            //             .required(t('Password verification is required')),
            // }
            // )}
            >
                {({ values, handleChange, errors, setFieldTouched, touched, isValid, handleSubmit, handleBlur, setFieldValue, validateForm }) => {

                    return (
                        <Fragment>
                            <div className='card-body py-3' style={{ overflowY: 'auto' }}>
                                <div className="col-md-12">
                                    <label className="required form-label fs-7 fw-normal mb-2">
                                        {/* {t('Email Address')} */}
                                        {getValueFromResource('Email Address', dispatch, t)}
                                    </label>
                                    <input
                                        id='emailAddress'
                                        value={values.emailAddress}
                                        type="text"
                                        className="form-control fs-7 fw-normal"
                                        placeholder=
                                        // {t('Email Address')}
                                        {getValueFromResource('Email Address', dispatch, t)}
                                        autoCapitalize="none"
                                        // onChange={handleChange('emailAddress')}
                                        onChange={(e) => {
                                            handleChange(e)
                                            setEmailValidate(true)
                                        }}
                                        ref={defaultFocusRef}
                                    //onBlur={(e: any) => handleBlurValidateAll(setFieldTouched, values, validateForm, e)}
                                    />
                                </div>
                                {employeeValues.isCanvasLoader ? <CanvasLoader /> : <>

                                    <div style={{ paddingRight: 20 }}>
                                        {!emailvalidate ? (
                                            <p className='errorMsg'>{"Email is already taken"}</p>
                                        ) :
                                            touched.emailAddress && errors.emailAddress &&
                                            <p className='errorMsg' ref={emailmsgRef}>{errors.emailAddress as string}</p>

                                        }
                                    </div>
                                    <div className='card-header' style={{ marginLeft: '-30px' }}>
                                        <ul className='nav nav-stretch nav-line-tabs border-transparent flex-nowrap mt-4' role='tablist'>
                                            <li className='nav-item'>
                                                <a
                                                    className={clsx(`nav-link cursor-pointer`, { active: tab === 'Basic' })}
                                                    onClick={() => setTab('Basic')}
                                                    role='tab'
                                                >
                                                    {/* {t('Basic')} */}
                                                    {getValueFromResource('Basic', dispatch, t)}
                                                </a>
                                            </li>
                                            <li className='nav-item'>
                                                <a
                                                    className={clsx(`nav-link cursor-pointer`, { active: tab === 'Detail' })}
                                                    onClick={() => setTab('Detail')}
                                                    role='tab'
                                                >
                                                    {/* {t('Detail')} */}
                                                    {getValueFromResource('Detail', dispatch, t)}
                                                </a>
                                            </li>
                                            <li className='nav-item'>
                                                <a
                                                    className={clsx(`nav-link cursor-pointer`, { active: tab === 'Billing' })}
                                                    onClick={() => setTab('Billing')}
                                                    role='tab'
                                                >
                                                    {/* {t('Billing')} */}
                                                    {getValueFromResource('Billing', dispatch, t)}
                                                </a>
                                            </li>
                                            {showAttendance && <li className='nav-item'>
                                                <a
                                                    className={clsx(`nav-link cursor-pointer`, { active: tab === 'Attendance' })}
                                                    onClick={() => setTab('Attendance')}
                                                    role='tab'
                                                >
                                                    {/* {t('Billing')} */}
                                                    {getValueFromResource('Attendance', dispatch, t)}
                                                </a>
                                            </li>}
                                            <li className='nav-item'>
                                                <a
                                                    className={clsx(`nav-link cursor-pointer`, { active: tab === 'Advanced' })}
                                                    onClick={() => setTab('Advanced')}
                                                    role='tab'
                                                >
                                                    {/* {t('Advanced')} */}
                                                    {getValueFromResource('Advanced', dispatch, t)}
                                                </a>
                                            </li>
                                            <li className='nav-item'>
                                                <a
                                                    className={clsx(`nav-link cursor-pointer`, { active: tab === 'Other' })}
                                                    onClick={() => setTab('Other')}
                                                    role='tab'
                                                >
                                                    {/* {t('Other')} */}
                                                    {getValueFromResource('Other', dispatch, t)}
                                                </a>
                                            </li>
                                            {customFieldsArray && customFieldsArray.length > 0 &&
                                                <li className='nav-item'>
                                                    <a
                                                        className={clsx(`nav-link cursor-pointer`, { active: tab === 'CustomField' })}
                                                        onClick={() => setTab('CustomField')}
                                                        role='tab'
                                                    >
                                                        {/* {t('Custom Field')} */}
                                                        {getValueFromResource('Custom Field', dispatch, t)}
                                                    </a>
                                                </li>
                                            }
                                        </ul>
                                    </div>
                                    {/* <form className='form'> */}
                                    <div className='tab-content pt-6'>
                                        <div className={clsx('tab-pane', { active: tab === 'Basic' })}>
                                            <div className='row'>
                                                <div className="col-md-4">
                                                    <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                        {/* {t(`Employee Code`)} */}
                                                        {getValueFromResource('Employee Code', dispatch, t)}
                                                        <div
                                                            style={{marginBottom: "2px"}}
                                                            data-tooltip-id="tooltip-description"
                                                            data-tooltip-content={getValueFromResource('A unique identifier assigned to the employee for tracking and reporting purposes.', dispatch, t)}
                                                        >
                                                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon"/>
                                                        </div>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control fs-7 fw-normal"
                                                        id='EmployeeCode'
                                                        value={employeeValues.EmployeeCode}
                                                        onChange={handleTextChange}
                                                    />
                                                </div>
                                                <div className="col-md-4">
                                                    <label className="required form-label fs-7 fw-normal mb-2">
                                                        {/* {t(`First Name`)} */}
                                                        {getValueFromResource('First Name', dispatch, t)}
                                                    </label>
                                                    <input
                                                        type="text"
                                                        name="firstName"
                                                        className="form-control fs-7 fw-normal"
                                                        value={values.firstName}
                                                        onChange={handleChange('firstName')}
                                                    // onBlur={() => setFieldTouched('firstName')}
                                                    // onBlur={() => setFieldTouched('firstName')}
                                                    // onBlur={() => handleBlurValidateAll(setFieldTouched, values, validateForm)}
                                                    />
                                                    <div>
                                                        {touched.firstName && errors.firstName &&
                                                            <p className='errorMsg'>{errors.firstName as string}</p>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t(`Middle Name`)} */}
                                                        {getValueFromResource('Middle Name', dispatch, t)}
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control fs-7 fw-normal"
                                                        id='MiddleName'
                                                        value={employeeValues.MiddleName}
                                                        onChange={handleTextChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className='row mt-4'>
                                                <div className="col-md-4">
                                                    <label className="required form-label fs-7 fw-normal mb-2">
                                                        {/* {t(`Last Name`)} */}
                                                        {getValueFromResource('Last Name', dispatch, t)}
                                                    </label>
                                                    <input
                                                        type="text"
                                                        name="lastName"
                                                        className="form-control fs-7 fw-normal"
                                                        value={values.lastName}
                                                        onChange={handleChange('lastName')}
                                                    //onBlur={() => setFieldTouched('lastName')}
                                                    // onBlur={() => handleBlurValidateAll(setFieldTouched, values, validateForm)}
                                                    />
                                                    <div>

                                                        {touched.lastName && errors.lastName &&
                                                            <p className='errorMsg'>{errors.lastName as string}</p>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <label className="required form-label fs-7 fw-normal mb-2">
                                                        {/* {t(`Password`)} */}
                                                        {getValueFromResource('Password', dispatch, t)}
                                                    </label>
                                                    <div className="wrapper">
                                                        <input
                                                            // type="password"
                                                            type={showPassword ? 'text' : 'password'}
                                                            className="form-control fs-7 fw-normal"
                                                            name="password"
                                                            value={values.password}
                                                            onChange={handleChange('password')}
                                                            //  onBlur={() => setFieldTouched('password')}
                                                            // onBlur={() => handleBlurValidateAll(setFieldTouched, values, validateForm)}
                                                            autoComplete="new-password"
                                                        />
                                                        <span
                                                            className="insideField-Icons form-label fs-6 fw-normal cursor"
                                                            onClick={togglePasswordVisibility}
                                                        >
                                                            {showPassword ? (
                                                                <i className="bi bi-eye-slash-fill text-gray"></i>
                                                            ) : (
                                                                <i className="bi bi-eye-fill text-gray"></i>
                                                            )}
                                                        </span>
                                                    </div>
                                                    <div>
                                                        {touched.password && errors.password &&
                                                            <p className='errorMsg'>{errors.password as string}</p>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <label className="required form-label fs-7 fw-normal mb-2">
                                                        {/* {t(`Verify Password`)} */}
                                                        {getValueFromResource('Verify Password', dispatch, t)}
                                                    </label>
                                                    <div className="wrapper">
                                                        <input
                                                            // type="password"
                                                            type={showConfirmPassword ? 'text' : 'password'}
                                                            className="form-control fs-7 fw-normal"
                                                            name="verifyPassword"
                                                            value={values.verifyPassword}
                                                            onChange={handleChange('verifyPassword')}
                                                            // onBlur={() => setFieldTouched('verifyPassword')}
                                                            // onBlur={() => handleBlurValidateAll(setFieldTouched, values, validateForm)}
                                                            autoComplete="new-password"
                                                        />
                                                        <span
                                                            className="insideField-Icons form-label fs-6 fw-normal cursor"
                                                            onClick={toggleConfirmPasswordVisibility}
                                                        >
                                                            {showConfirmPassword ? (
                                                                <i className="bi bi-eye-slash-fill text-gray"></i>
                                                            ) : (
                                                                <i className="bi bi-eye-fill text-gray"></i>
                                                            )}
                                                        </span>
                                                    </div>
                                                    <div>
                                                        {touched.verifyPassword && errors.verifyPassword &&
                                                            <p className='errorMsg'>{errors.verifyPassword as string}</p>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='row mt-4'>
                                                <div className="col-md-4">
                                                    <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                        {/* {t(`Role`)} */}
                                                        {getValueFromResource('Role', dispatch, t)}
                                                        <div
                                                            style={{marginBottom: "2px"}}
                                                            data-tooltip-id="tooltip-description"
                                                            data-tooltip-content={getValueFromResource("Select the employee's job role or designation within the organization.", dispatch, t)}
                                                        >
                                                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon"/>
                                                        </div>
                                                    </label>
                                                    <Select
                                                        //value={employeeResponse.Role.filter((x: any) => x.value == employeeValues.AccountRoleId)}
                                                        value={employeeResponse.Role.filter((x: any) => x.value == values.AccountRoleId)}
                                                        className="basic-single fs-7 fw-normal"
                                                        classNamePrefix="select"
                                                        //name="roleList"
                                                        name="AccountRoleId"
                                                        id='AccountRoleId'
                                                        //onChange={(e, name) => onChange(e, name)}
                                                        // onChange={handleChange('AccountRoleId')}
                                                        onChange={(selectedOption: any) => {
                                                            handleChange({
                                                                target: {
                                                                    id: "AccountRoleId",
                                                                    value: selectedOption?.value
                                                                },
                                                            });
                                                        }}
                                                        menuPlacement="auto"
                                                        options={employeeResponse.Role}
                                                        styles={dropDownSelectionStyles}
                                                        maxMenuHeight={maxMenuHeight}
                                                        isDisabled={
                                                            accountemployeeid !== 0 && currentUserId === accountemployeeid.toString()
                                                        }
                                                        menuPosition="fixed"
                                                    />
                                                    <div>
                                                        {touched.AccountRoleId && errors.AccountRoleId &&
                                                            <p className='errorMsg'>{errors.AccountRoleId as string}</p>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t(`Department`)} */}
                                                        {getValueFromResource('Department', dispatch, t)}
                                                    </label>
                                                    <Select
                                                        // value={employeeResponse.Department.filter((x: any) => x.value == employeeValues.AccountDepartmentId)}
                                                        value={employeeResponse.Department.filter((x: any) => x.value == values.AccountDepartmentId)}
                                                        className="basic-single fs-7 fw-normal"
                                                        classNamePrefix="select"
                                                        //name="departmentList"
                                                        name="AccountDepartmentId"
                                                        id='AccountDepartmentId'
                                                        // onChange={(e, name) => onChange(e, name)}
                                                        onChange={(selectedOption: any) => {
                                                            handleChange({
                                                                target: {
                                                                    id: "AccountDepartmentId",
                                                                    value: selectedOption?.value
                                                                },
                                                            });
                                                        }}
                                                        options={employeeResponse.Department}
                                                        styles={dropDownSelectionStyles}
                                                        maxMenuHeight={maxMenuHeight}
                                                        menuPlacement="auto"
                                                        menuPosition="fixed"
                                                    />
                                                    <div>
                                                        {touched.AccountDepartmentId && errors.AccountDepartmentId &&
                                                            <p className='errorMsg'>{errors.AccountDepartmentId as string}</p>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t(`Location`)} */}
                                                        {getValueFromResource('Location', dispatch, t)}
                                                    </label>
                                                    <Select
                                                        //value={employeeResponse.Location.filter((x: any) => x.value == employeeValues.AccountLocationId)}
                                                        value={employeeResponse.Location.filter((x: any) => x.value == values.AccountLocationId)}
                                                        className="basic-single fs-7 fw-normal"
                                                        classNamePrefix="select"
                                                        //name="locationList"
                                                        name="AccountLocationId"
                                                        id='AccountLocationId'
                                                        //onChange={(e, name) => onChange(e, name)}
                                                        onChange={(selectedOption: any) => {
                                                            handleChange({
                                                                target: {
                                                                    id: "AccountLocationId",
                                                                    value: selectedOption?.value
                                                                },
                                                            });
                                                        }}
                                                        options={employeeResponse.Location}
                                                        styles={dropDownSelectionStyles}
                                                        maxMenuHeight={maxMenuHeight}
                                                        menuPlacement="auto"
                                                        menuPosition="fixed"
                                                    />
                                                    <div>
                                                        {touched.AccountLocationId && errors.AccountLocationId &&
                                                            <p className='errorMsg'>{errors.AccountLocationId as string}</p>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={clsx('tab-pane', { active: tab === 'Detail' })}>
                                            <div className='row'>
                                                <div className="col-md-4">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t(`Address Line 1`)} */}
                                                        {getValueFromResource('Address Line 1', dispatch, t)}
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control fs-7 fw-normal"
                                                        id='AddressLine1'
                                                        value={employeeValues.AddressLine1}
                                                        onChange={handleTextChange}
                                                    />
                                                </div>
                                                <div className="col-md-4">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t(`Address Line 2`)} */}
                                                        {getValueFromResource('Address Line 2', dispatch, t)}
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control fs-7 fw-normal"
                                                        id='AddressLine2'
                                                        value={employeeValues.AddressLine2}
                                                        onChange={handleTextChange}
                                                    />
                                                </div>
                                                <div className="col-md-4">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t(`City`)} */}
                                                        {getValueFromResource('City', dispatch, t)}
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control fs-7 fw-normal"
                                                        id='City'
                                                        value={employeeValues.City}
                                                        onChange={handleTextChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className='row mt-4'>
                                                <div className="col-md-4">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t(`State`)} */}
                                                        {getValueFromResource('State', dispatch, t)}
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control fs-7 fw-normal"
                                                        id='State'
                                                        value={employeeValues.State}
                                                        onChange={handleTextChange}
                                                    />
                                                </div>
                                                <div className="col-md-4">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t(`Country`)} */}
                                                        {getValueFromResource('Country', dispatch, t)}
                                                    </label>
                                                    <Select
                                                        //value={employeeResponse.Country.filter((x: any) => x.value == employeeValues.CountryId)}
                                                        value={employeeResponse.Country.filter((x: any) => x.value == values.CountryId)}
                                                        className="basic-single fs-7 fw-normal"
                                                        classNamePrefix="select"
                                                        // name="countryList"
                                                        // onChange={(e, name) => onChange(e, name)}
                                                        name="CountryId"
                                                        id='CountryId'
                                                        //onChange={(e, name) => onChange(e, name)}
                                                        onChange={(selectedOption: any) => {
                                                            handleChange({
                                                                target: {
                                                                    id: "CountryId",
                                                                    value: selectedOption?.value
                                                                },
                                                            });
                                                        }}
                                                        options={employeeResponse.Country}
                                                        styles={dropDownSelectionStyles}
                                                        maxMenuHeight={maxMenuHeight}
                                                    />
                                                    <div>
                                                        {touched.CountryId && errors.CountryId &&
                                                            <p className='errorMsg'>{errors.CountryId as string}</p>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t(`Zip`)} */}
                                                        {getValueFromResource('Zip', dispatch, t)}
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control fs-7 fw-normal"
                                                        id='Zip'
                                                        value={employeeValues.Zip}
                                                        onChange={handleTextChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className='row mt-4'>
                                                <div className="col-md-4">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t(`Home Phone No`)} */}
                                                        {getValueFromResource('Home Phone No', dispatch, t)}
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control fs-7 fw-normal"
                                                        id='HomePhoneNo'
                                                        value={employeeValues.HomePhoneNo}
                                                        onChange={handleTextChange}
                                                    />
                                                </div>
                                                <div className="col-md-4">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t(`Work Phone No`)} */}
                                                        {getValueFromResource('Work Phone No', dispatch, t)}
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control fs-7 fw-normal"
                                                        id='WorkPhoneNo'
                                                        value={employeeValues.WorkPhoneNo}
                                                        onChange={handleTextChange}
                                                    />
                                                </div>
                                                <div className="col-md-4">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t(`Mobile Phone No`)} */}
                                                        {getValueFromResource('Mobile Phone No', dispatch, t)}
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control fs-7 fw-normal"
                                                        id='MobilePhoneNo'
                                                        value={employeeValues.MobilePhoneNo}
                                                        onChange={handleTextChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className={clsx('tab-pane', { active: tab === 'Billing' })}>
                                            <div className='row'>

                                                <div className="col-md-4">
                                                    <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                        {/* {t(`Work Type`)} */}
                                                        {getValueFromResource('Work Type', dispatch, t)}
                                                        <div
                                                            style={{marginBottom: "2px"}}
                                                            data-tooltip-id="tooltip-description"
                                                            data-tooltip-content={getValueFromResource('Defines how the employee works, such as On-site, Remote, Hybrid, or Field-based.', dispatch, t)}
                                                        >
                                                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon"/>
                                                        </div>
                                                    </label>
                                                    <Select
                                                        //value={employeeResponse.WorkType.filter((x: any) => x.value == employeeValues.AccountWorkTypeId)}
                                                        value={employeeResponse.WorkType.filter((x: any) => x.value == values.AccountWorkTypeId)}
                                                        className="basic-single fs-7 fw-normal"
                                                        classNamePrefix="select"
                                                        //name="worktypeList"
                                                        name="AccountWorkTypeId"
                                                        id='AccountWorkTypeId'
                                                        //onChange={(e, name) => onChange(e, name)}
                                                        //onChange={(e) => onDropdownChange1(e)}
                                                        onChange={(selectedOption: any) => {
                                                            // const updatedEmployeeYup = { ...employeeValues.employeeYup };
                                                            // updatedEmployeeYup.AccountWorkTypeId = selectedOption?.value;
                                                            setWorkTypeId(selectedOption?.value);
                                                            handleChange({
                                                                target: {
                                                                    id: "AccountWorkTypeId",
                                                                    value: selectedOption?.value
                                                                },
                                                            });
                                                            // setemployeeValues({
                                                            //     ...employeeValues,
                                                            //     employeeYup: updatedEmployeeYup
                                                            // });
                                                        }}
                                                        options={employeeResponse.WorkType}
                                                        styles={dropDownSelectionStyles}
                                                        maxMenuHeight={maxMenuHeight}
                                                    />
                                                    <div>
                                                        {touched.AccountWorkTypeId && errors.AccountWorkTypeId &&
                                                            <p className='errorMsg'>{errors.AccountWorkTypeId as string}</p>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                        {/* {t(`Billing Type`)} */}
                                                        {getValueFromResource('Billing Type', dispatch, t)}
                                                        <div
                                                            style={{marginBottom: "2px"}}
                                                            data-tooltip-id="tooltip-description"
                                                            data-tooltip-content={getValueFromResource("Determines how the employee's work is billed to customers or projects.", dispatch, t)}
                                                        >
                                                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon"/>
                                                        </div>
                                                    </label>
                                                    <Select
                                                        //value={employeeResponse.BillingType.filter((x: any) => x.value == employeeValues.AccountBillingTypeId)}
                                                        value={employeeResponse.BillingType.filter((x: any) => x.value == values.AccountBillingTypeId)}
                                                        className="basic-single fs-7 fw-normal"
                                                        classNamePrefix="select"
                                                        // name="billingtypeList"
                                                        // onChange={(e, name) => onChange(e, name)}
                                                        name="AccountBillingTypeId"
                                                        id='AccountBillingTypeId'
                                                        onChange={(selectedOption: any) => {
                                                            handleChange({
                                                                target: {
                                                                    id: "AccountBillingTypeId",
                                                                    value: selectedOption?.value
                                                                },
                                                            });
                                                        }}
                                                        options={employeeResponse.BillingType}
                                                        styles={dropDownSelectionStyles}
                                                        maxMenuHeight={maxMenuHeight}
                                                    />
                                                    <div>
                                                        {touched.AccountBillingTypeId && errors.AccountBillingTypeId &&
                                                            <p className='errorMsg'>{errors.AccountBillingTypeId as string}</p>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                        {getValueFromResource('Employee Rate', dispatch, t)}
                                                        <div
                                                            style={{marginBottom: "2px"}}
                                                            data-tooltip-id="tooltip-description"
                                                            data-tooltip-content={getValueFromResource("The internal cost rate associated with the employee's work.", dispatch, t)}
                                                        >
                                                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon"/>
                                                        </div>
                                                    </label>
                                                    {/*                                                     <input
                                                        type="Number"
                                                        className="form-control fs-7 fw-normal"
                                                        id='EmployeeRate'
                                                        value={employeeRateValue}
                                                        onChange={(e: any) => setEmployeeRateValue(e.target.value)}
                                                    /> */}

                                                    <input
                                                        type="text"
                                                        className="form-control fs-7 fw-normal"
                                                        id="EmployeeRate"
                                                        name="EmployeeRate"
                                                        value={employeeRateValue}
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            const isUSCulture = cultureInfoName.toString();

                                                            if (validateCultureNumber(value, cultureInfoName.toString(), decimalPlaces)) {
                                                                setEmployeeRateValue(value);
                                                            }
                                                        }}
                                                        onBlur={(e) => {
                                                            //const isUSCulture = /* your culture check */;
                                                            const formatted = formatNumberCustomoriginal(
                                                                cultureInfoName.toString(),
                                                                e.target.value,
                                                                decimalPlaces
                                                            );
                                                            setFieldValue("EmployeeRate", formatted);
                                                            setEmployeeRateValue(formatted);
                                                        }}

                                                    />
                                                </div>
                                            </div>
                                            <div className='row mt-4'>
                                                <div className="col-md-4">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t(`Employee Rate Currency`)} */}
                                                        {getValueFromResource('Employee Rate Currency', dispatch, t)}
                                                    </label>
                                                    <Select
                                                        //value={employeeResponse.EmployeeRateCurrency.filter((x: any) => x.value == employeeValues.EmployeeRateCurrencyId)}
                                                        value={employeeResponse.EmployeeRateCurrency.filter((x: any) => x.value == values.EmployeeRateCurrencyId)}
                                                        className="basic-single fs-7 fw-normal"
                                                        classNamePrefix="select"
                                                        //name="employeeratecurrencyList"
                                                        name="EmployeeRateCurrencyId"
                                                        id='EmployeeRateCurrencyId'
                                                        //onChange={(e, name) => onChange(e, name)}
                                                        onChange={(selectedOption: any) => {
                                                            handleChange({
                                                                target: {
                                                                    id: "EmployeeRateCurrencyId",
                                                                    value: selectedOption?.value
                                                                },
                                                            });
                                                        }}
                                                        options={employeeResponse.EmployeeRateCurrency}
                                                        styles={dropDownSelectionStyles}
                                                        maxMenuHeight={maxMenuHeight}
                                                    />
                                                    <div>
                                                        {touched.EmployeeRateCurrencyId && errors.EmployeeRateCurrencyId &&
                                                            <p className='errorMsg'>{errors.EmployeeRateCurrencyId as string}</p>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t(`Billing Rate Currency`)} */}
                                                        {getValueFromResource('Billing Rate Currency', dispatch, t)}
                                                    </label>
                                                    <Select
                                                        //value={employeeResponse.BillingRateCurrency.filter((x: any) => x.value == employeeValues.BillingRateCurrencyId)}
                                                        value={employeeResponse.BillingRateCurrency.filter((x: any) => x.value == values.BillingRateCurrencyId)}
                                                        className="basic-single fs-7 fw-normal"
                                                        classNamePrefix="select"
                                                        // name="billingratecurrencyList"
                                                        // onChange={(e, name) => onChange(e, name)}
                                                        name="BillingRateCurrencyId"
                                                        id='BillingRateCurrencyId'
                                                        onChange={(selectedOption: any) => {
                                                            handleChange({
                                                                target: {
                                                                    id: "BillingRateCurrencyId",
                                                                    value: selectedOption?.value
                                                                },
                                                            });
                                                        }}
                                                        options={employeeResponse.BillingRateCurrency}
                                                        styles={dropDownSelectionStyles}
                                                        maxMenuHeight={maxMenuHeight}
                                                    />
                                                    <div>
                                                        {touched.BillingRateCurrencyId && errors.BillingRateCurrencyId &&
                                                            <p className='errorMsg'>{errors.BillingRateCurrencyId as string}</p>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                        {getValueFromResource('Billing Rate', dispatch, t)}
                                                        <div
                                                            style={{marginBottom: "2px"}}
                                                            data-tooltip-id="tooltip-description"
                                                            data-tooltip-content={getValueFromResource("The rate charged to customers for the employee's billable work.", dispatch, t)}
                                                        >
                                                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon"/>
                                                        </div>
                                                    </label>
                                                    {/*                                                     <input
                                                        type="Number"
                                                        className="form-control fs-7 fw-normal"
                                                        id='BillingRate'
                                                        value={billingRateValue}
                                                        onChange={(e: any) => setBillingRateValue(e.target.value)}
                                                    /> */}
                                                    <input
                                                        type="text"
                                                        className="form-control fs-7 fw-normal"
                                                        id="BillingRate"
                                                        name="BillingRate"
                                                        value={billingRateValue}
                                                        //onChange={handleChange('EmployeeRate')}
                                                        onChange={(e: any) => {
                                                            const val = e.target.value;
                                                            /*   if (!validateCultureNumber(val, cultureInfoName.toString(), decimalPlaces)) {
                                                                return;
                                                              } */
                                                            //setBillingRateValue(val);

                                                            if (validateCultureNumber(val, cultureInfoName.toString(), decimalPlaces)) {
                                                                setBillingRateValue(val);
                                                            }
                                                        }}
                                                        onBlur={(e) => {
                                                            const formatted = formatNumberCustomoriginal(
                                                                cultureInfoName.toString(),
                                                                e.target.value,
                                                                decimalPlaces
                                                            );
                                                            setFieldValue("BillingRate", formatted);
                                                            setBillingRateValue(formatted);

                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className='row mt-4'>
                                                <div className="col-md-4">
                                                    <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                        {/* {t(`Billing Rate Start Date`)} */}
                                                        {getValueFromResource('Billing Rate Start Date', dispatch, t)}
                                                        <div
                                                            style={{marginBottom: "2px"}}
                                                            data-tooltip-id="tooltip-description"
                                                            data-tooltip-content={getValueFromResource('The date from which the selected billing rate becomes effective.', dispatch, t)}
                                                        >
                                                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon"/>
                                                        </div>
                                                    </label>
                                                    <div className="wrapper">
                                                        <DatePicker
                                                            selected={employeeValues.BillingRateStartDate}
                                                            onChange={(date) => onDateChange(date, "BillingRateStartDate")}
                                                            calendarStartDay={calendarStartDay}
                                                            className="form-control dataPicker form-control-dark btn-icon-dark btn-text-dark"
                                                            dateFormat={CurrentCultureDateFormat.toString()}
                                                        >
                                                        </DatePicker>
                                                        <i className="insideField-Icons ki-outline ki-calendar text-gray"></i>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                        {/* {t(`Billing Rate End Date`)} */}
                                                        {getValueFromResource('Billing Rate End Date', dispatch, t)}
                                                        <div
                                                            style={{marginBottom: "2px"}}
                                                            data-tooltip-id="tooltip-description"
                                                            data-tooltip-content={getValueFromResource('The date until which the selected billing rate remains effective. Leave blank if there is no end date.', dispatch, t)}
                                                        >
                                                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon"/>
                                                        </div>
                                                    </label>
                                                    <div className="wrapper">
                                                        <DatePicker
                                                            selected={employeeValues.BillingRateEndDate}
                                                            onChange={(date) => onDateChange(date, "BillingRateEndDate")}
                                                            calendarStartDay={calendarStartDay}
                                                            className="form-control dataPicker form-control-dark btn-icon-dark btn-text-dark"
                                                            dateFormat={CurrentCultureDateFormat.toString()}
                                                        >
                                                        </DatePicker>
                                                        <i className="insideField-Icons ki-outline ki-calendar text-gray"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {showAttendance && <div className={clsx('tab-pane', { active: tab === 'Attendance' })}>
                                            <div className='row'>
                                                <div className="col-md-4">
                                                    <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                        {getValueFromResource('Employee Pin', dispatch, t)}
                                                        <div
                                                            style={{marginBottom: "2px"}}
                                                            data-tooltip-id="tooltip-description"
                                                            data-tooltip-content={getValueFromResource('A personal identification number used for attendance, kiosk, or secure employee authentication.', dispatch, t)}
                                                        >
                                                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon"/>
                                                        </div>
                                                    </label>
                                                    <div className="wrapper">
                                                        <input
                                                            name="employeePinCode"
                                                            type="text"
                                                            id="employeePinCode"
                                                            className="form-control input-disp-valid fs-7 fw-normal"
                                                            value={employeeValues.pinCode}
                                                            onChange={handleTextChange}
                                                            style={{ flex: 1 }}
                                                        />
                                                        <i className="insideField-Icons fa fa-refresh text-gray cursor-pointer"
                                                            onClick={handleRegeneratePin}
                                                        ></i>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                        {/* {t(`Shift`)} */}
                                                        {getValueFromResource('Shift', dispatch, t)}
                                                        <div
                                                            style={{marginBottom: "2px"}}
                                                            data-tooltip-id="tooltip-description"
                                                            data-tooltip-content={getValueFromResource("Assign the employee's default work shift for scheduling and attendance calculations.", dispatch, t)}
                                                        >
                                                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon"/>
                                                        </div>
                                                    </label>
                                                    <Select
                                                        value={employeeResponse.Shift.filter((x: any) => x.value == employeeValues.AccountShiftId)}
                                                        className="basic-single fs-7 fw-normal"
                                                        classNamePrefix="select"
                                                        name="shiftList"
                                                        onChange={(e, name) => onChange(e, name)}
                                                        options={employeeResponse.Shift}
                                                        styles={dropDownSelectionStyles}
                                                        maxMenuHeight={maxMenuHeight}
                                                        menuPlacement="auto"
                                                        menuPosition="fixed"
                                                    />
                                                </div>
                                                {showGeofence ? (
                                                    <div className="col-md-4">
                                                    <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                        {getValueFromResource('Geofence Profile', dispatch, t)}
                                                        <div
                                                            style={{marginBottom: "2px"}}
                                                            data-tooltip-id="tooltip-description"
                                                            data-tooltip-content={getValueFromResource('Assign the location rules that determine where attendance can be recorded.', dispatch, t)}
                                                        >
                                                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon"/>
                                                        </div>
                                                    </label>
                                                    <Select
                                                        value={geofenceProfileOptions?.find((item) => item?.value === selectedGeofenceprofile)}
                                                        className="basic-single fs-7 fw-normal"
                                                        classNamePrefix="select"
                                                        name="geofenceProfileId"
                                                        id='geofenceProfileId'
                                                        onChange={(selectedOption: any) => setSelectedGeofenceProfile(selectedOption?.value)}
                                                        options={geofenceProfileOptions}
                                                        styles={dropDownSelectionStyles}
                                                        maxMenuHeight={maxMenuHeight}
                                                    />
                                                </div>
                                                ) : (
                                                    <div className="col-md-4">
                                                        <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                            {getValueFromResource('Biometric User ID', dispatch, t)}
                                                            <div
                                                                style={{ marginBottom: "2px" }}
                                                                data-tooltip-id="tooltip-description"
                                                                data-tooltip-content={getValueFromResource('Identifies the employee on the biometric attendance device. This value must match the User ID configured on the biometric device.', dispatch, t)}
                                                            >
                                                                <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                            </div>
                                                        </label>
                                                        <input
                                                            name="biometricUserId"
                                                            type="text"
                                                            id="biometricUserId"
                                                            className="form-control input-disp-valid fs-7 fw-normal"
                                                            value={employeeValues.biometricUserId}
                                                            onChange={handleTextChange}
                                                            style={{ flex: 1 }}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                            <div className="row spacingBetweenRows">
                                                {showGeofence && (
                                                <div className="col-md-4">
                                                    <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                        {getValueFromResource('Biometric User ID', dispatch, t)}
                                                        <div
                                                            style={{marginBottom: "2px"}}
                                                            data-tooltip-id="tooltip-description"
                                                            data-tooltip-content={getValueFromResource('Identifies the employee on the biometric attendance device. This value must match the User ID configured on the biometric device.', dispatch, t)}
                                                        >
                                                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon"/>
                                                        </div>
                                                    </label>
                                                        <input
                                                            name="biometricUserId"
                                                            type="text"
                                                            id="biometricUserId"
                                                            className="form-control input-disp-valid fs-7 fw-normal"
                                                            value={employeeValues.biometricUserId}
                                                            onChange={handleTextChange}
                                                            style={{ flex: 1 }}
                                                        />
                                                </div>
                                                )}
                                                <div className="col-md-4">
                                                    <label className="form-label fs-7 fw-normal mb-3">
                                                        {getValueFromResource('Assigned Attendance Policy', dispatch, t)}
                                                    </label>
                                                    <div>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-solid fs-7"
                                                            value={employeeValues.AttendancePolicyName || 'None'}
                                                            disabled
                                                            readOnly
                                                        />
                                                    </div>
                                                </div>
 
                                                <div className="col-md-4">
                                                    <label className="form-label fs-7 fw-normal mb-3">
                                                        {getValueFromResource('Allow Attendance From Web App', dispatch, t)}
                                                    </label>
                                                    <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                        <input className="form-check-input fs-7 fw-normal h-20px w-30px"
                                                            type="checkbox"
                                                            checked={employeeValues.AllowAttendanceFromWebApp}
                                                            id="AllowAttendanceFromWebApp"
                                                            name="AllowAttendanceFromWebApp"
                                                            onChange={(e) => { onSwitch(e) }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            {accountemployeeid !== 0 && (
                                                <div className="row spacingBetweenRows">
                                                    <div className="col-md-12">
                                                        <label className="form-label fs-7 fw-normal mb-3 d-flex align-items-center gap-1">
                                                            {getValueFromResource('Employee QR Code', dispatch, t)}
                                                            <div
                                                                style={{marginBottom: "2px"}}
                                                                data-tooltip-id="tooltip-description"
                                                                data-tooltip-content={getValueFromResource('Generates or assigns a QR code that can be used for attendance or employee identification.', dispatch, t)}
                                                            >
                                                                <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon"/>
                                                            </div>
                                                        </label>
                                                        <div style={{
                                                            border: '1px solid #e4e6ef',
                                                            borderRadius: '12px',
                                                            overflow: 'hidden',
                                                            display: 'flex',
                                                            flexDirection: 'row',
                                                            alignItems: 'stretch',
                                                            background: '#fff'
                                                        }}>

                                                            <div style={{
                                                                minWidth: '190px',
                                                                background: '#f5f8ff',
                                                                borderRight: '1px solid #e4e6ef',
                                                            }}>
                                                                <div ref={qrRef}>
                                                                    <QRCodeCanvas
                                                                        value={qrPayload}
                                                                        size={190}
                                                                        level="H"
                                                                        marginSize={2}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div style={{
                                                                flex: 1,
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                padding: '16px 18px',
                                                                gap: '10px'
                                                            }}>
                                                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                                    <div style={{
                                                                        width: '34px', height: '34px',
                                                                        borderRadius: '50%',
                                                                        background: '#dbeafe',
                                                                        display: 'flex', alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        fontSize: '12px', fontWeight: '600',
                                                                        color: '#1e40af',
                                                                        flexShrink: 0
                                                                    }}>
                                                                        {`${employeeValues.employeeYup?.firstName?.charAt(0) || ''}${employeeValues.employeeYup?.lastName?.charAt(0) || ''}`}
                                                                    </div>
                                                                    <div>
                                                                        <div style={{ fontSize: '13px', fontWeight: '600', color: '#1e293b', lineHeight: '1.3' }}>
                                                                            {employeeValues.employeeYup?.firstName} {employeeValues.employeeYup?.lastName}
                                                                        </div>
                                                                        <div style={{ fontSize: '12px', color: '#94a3b8' }}>
                                                                            {employeeValues.employeeYup?.emailAddress}
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '7px', fontSize: '12px', color: '#64748b' }}>
                                                                        <i className="bi bi-person iconColor fs-6"></i>
                                                                        <span>{getValueFromResource('Employee ID', dispatch, t)} <strong style={{ color: '#1e293b' }}>{accountemployeeid}</strong></span>
                                                                    </div>

                                                                    {(selectedGeofenceprofile !== 0 && showGeofence) && (
                                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '7px', fontSize: '12px', color: '#64748b' }}>
                                                                            <i className="bi bi-geo-alt iconColor fs-6"></i>
                                                                            <span>
                                                                                {(geofenceProfileOptions as any[])?.find((x: any) => x.value === selectedGeofenceprofile)?.label || ''}
                                                                            </span>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-primary btn-sm fs-7 w-100"
                                                                    onClick={handleDownloadQR}
                                                                    style={{ marginTop: '4px' }}
                                                                >
                                                                    <i className="bi bi-download me-2"></i>
                                                                    {getValueFromResource('Download QR', dispatch, t)}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>}
                                        <div className={clsx('tab-pane', { active: tab === 'Advanced' })}>
                                            <div className='row'>
                                                <div className="col-md-4">
                                                    <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                        {/* {t(`Working Day Type`)} */}
                                                        {getValueFromResource('Working Day Type', dispatch, t)}
                                                        <div
                                                            style={{marginBottom: "2px"}}
                                                            data-tooltip-id="tooltip-description"
                                                            data-tooltip-content={getValueFromResource("Specifies the employee's standard working week, such as Monday–Friday or rotating schedules.", dispatch, t)}
                                                        >
                                                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon"/>
                                                        </div>
                                                    </label>
                                                    <Select
                                                        //value={employeeResponse.WorkingDayType.filter((x: any) => x.value == employeeValues.AccountWorkingDayTypeId)}
                                                        value={employeeResponse.WorkingDayType.filter((x: any) => x.value == values.AccountWorkingDayTypeId)}
                                                        className="basic-single fs-7 fw-normal"
                                                        classNamePrefix="select"
                                                        //name="workingdaytypeList"
                                                        //onChange={(e, name) => onChange(e, name)}
                                                        name="AccountWorkingDayTypeId"
                                                        id='AccountWorkingDayTypeId'
                                                        onChange={(selectedOption: any) => {
                                                            handleChange({
                                                                target: {
                                                                    id: "AccountWorkingDayTypeId",
                                                                    value: selectedOption?.value
                                                                },
                                                            });
                                                        }}
                                                        options={employeeResponse.WorkingDayType}
                                                        styles={dropDownSelectionStyles}
                                                        maxMenuHeight={maxMenuHeight}
                                                    />
                                                    <div>
                                                        {touched.AccountWorkingDayTypeId && errors.AccountWorkingDayTypeId &&
                                                            <p className='errorMsg'>{errors.AccountWorkingDayTypeId as string}</p>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                        {/* {t(`Employee Status`)} */}
                                                        {getValueFromResource('Employee Status', dispatch, t)}
                                                        <div
                                                            style={{marginBottom: "2px"}}
                                                            data-tooltip-id="tooltip-description"
                                                            data-tooltip-content={getValueFromResource('Indicates whether the employee is Active, Inactive, On Leave, or another configured status.', dispatch, t)}
                                                        >
                                                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon"/>
                                                        </div>
                                                    </label>
                                                    <Select
                                                        //value={employeeResponse.EmployeeStatus.filter((x: any) => x.value == employeeValues.AccountStatusId)}
                                                        value={employeeResponse.EmployeeStatus.filter((x: any) => x.value == values.AccountStatusId)}
                                                        className="basic-single fs-7 fw-normal"
                                                        classNamePrefix="select"
                                                        //name="employeestatusList"
                                                        //onChange={(e, name) => onChange(e, name)}
                                                        name="AccountStatusId"
                                                        id='AccountStatusId'
                                                        onChange={(selectedOption: any) => {
                                                            handleChange({
                                                                target: {
                                                                    id: "AccountStatusId",
                                                                    value: selectedOption?.value
                                                                },
                                                            });
                                                        }}
                                                        options={employeeResponse.EmployeeStatus}
                                                        styles={dropDownSelectionStyles}
                                                        maxMenuHeight={maxMenuHeight}
                                                    />
                                                    <div>
                                                        {touched.AccountStatusId && errors.AccountStatusId &&
                                                            <p className='errorMsg'>{errors.AccountStatusId as string}</p>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t(`User Interface Language`)} */}
                                                        {getValueFromResource('User Interface Language', dispatch, t)}
                                                    </label>
                                                    <Select
                                                        //value={employeeResponse.UserInterfaceLanguage.filter((x: any) => x.value == employeeValues.UserInterfaceLanguageId)}
                                                        value={employeeResponse.UserInterfaceLanguage.filter((x: any) => x.value == values.UserInterfaceLanguageId)}
                                                        className="basic-single fs-7 fw-normal"
                                                        classNamePrefix="select"
                                                        //name="userintefacelanguageList"
                                                        //onChange={(e, name) => onChange(e, name)}
                                                        name="UserInterfaceLanguageId"
                                                        id='UserInterfaceLanguageId'
                                                        onChange={(selectedOption: any) => {
                                                            handleChange({
                                                                target: {
                                                                    id: "UserInterfaceLanguageId",
                                                                    value: selectedOption?.value
                                                                },
                                                            });
                                                            localStorage.setItem("selectedLanguage", selectedOption?.value);
                                                        }}
                                                        options={employeeResponse.UserInterfaceLanguage}
                                                        styles={dropDownSelectionStyles}
                                                        maxMenuHeight={maxMenuHeight}
                                                    />
                                                    <div>
                                                        {touched.UserInterfaceLanguageId && errors.UserInterfaceLanguageId &&
                                                            <p className='errorMsg'>{errors.UserInterfaceLanguageId as string}</p>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='row spacingBetweenRows'>
                                                <div className="col-md-4">
                                                    <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                        {/* {t(`Employee Time Off Policy`)} */}
                                                        {getValueFromResource('Employee Time Off Policy', dispatch, t)}
                                                        <div
                                                            style={{marginBottom: "2px"}}
                                                            data-tooltip-id="tooltip-description"
                                                            data-tooltip-content={getValueFromResource("Assign the leave policy that determines the employee's available leave types and accrual rules.", dispatch, t)}
                                                        >
                                                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon"/>
                                                        </div>
                                                    </label>
                                                    <Select
                                                        value={employeeResponse.EmployeeTimeOffPolicy.filter((x: any) => x.value == employeeValues.AccountTimeOffPolicyId)}
                                                        className="basic-single fs-7 fw-normal"
                                                        classNamePrefix="select"
                                                        name="employeetimeoffpolicyList"
                                                        onChange={(e, name) => onChange(e, name)}
                                                        options={employeeResponse.EmployeeTimeOffPolicy}
                                                        styles={dropDownSelectionStyles}
                                                        maxMenuHeight={maxMenuHeight}
                                                    />
                                                </div>
                                                <div className="col-md-4">
                                                    <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                        {/* {t(`Time Off Approval Type`)} */}
                                                        {getValueFromResource('Time Off Approval Type', dispatch, t)}
                                                        <div
                                                            style={{marginBottom: "2px"}}
                                                            data-tooltip-id="tooltip-description"
                                                            data-tooltip-content={getValueFromResource('Defines the approval workflow used when the employee submits time off requests.', dispatch, t)}
                                                        >
                                                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon"/>
                                                        </div>
                                                    </label>
                                                    <Select
                                                        value={employeeResponse.TimeOffApprovalType.filter((x: any) => x.value == employeeValues.AccountApprovalTypeId)}
                                                        className="basic-single fs-7 fw-normal"
                                                        classNamePrefix="select"
                                                        name="timeoffapprovaltypeList"
                                                        onChange={(e, name) => onChange(e, name)}
                                                        options={employeeResponse.TimeOffApprovalType}
                                                        styles={dropDownSelectionStyles}
                                                        maxMenuHeight={maxMenuHeight}
                                                    />
                                                </div>
                                                <div className="col-md-4">
                                                    <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                        {/* {t(`Employee Manager`)} */}
                                                        {getValueFromResource('Employee Manager', dispatch, t)}
                                                        <div
                                                            style={{marginBottom: "2px"}}
                                                            data-tooltip-id="tooltip-description"
                                                            data-tooltip-content={getValueFromResource("Select the employee's direct manager for approvals, reporting, and organizational hierarchy.", dispatch, t)}
                                                        >
                                                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon"/>
                                                        </div>
                                                    </label>
                                                    <div onScroll={handleScroll}>
                                                        <Select
                                                            value={selectedEmployee}
                                                            className="basic-single fs-7 fw-normal"
                                                            classNamePrefix="select"
                                                            name="employeemanagerList"
                                                            onChange={handleChangeOption}
                                                            options={data}
                                                            styles={dropDownSelectionStyles}
                                                            maxMenuHeight={maxMenuHeight}
                                                            onInputChange={handleInputChange}
                                                            components={{ MenuList: customMenuList }}
                                                        />
                                                    </div>
                                                    {/* <Select
                                                value={employeeResponse.EmployeeManager.filter((x: any) => x.value == employeeValues.EmployeeManagerId)}
                                                className="basic-single fs-7 fw-normal"
                                                classNamePrefix="select"
                                                name="employeemanagerList"
                                                onChange={(e, name) => onChange(e, name)}
                                                options={employeeResponse.EmployeeManager}
                                                styles={dropDownSelectionStyles}
                                                maxMenuHeight={maxMenuHeight}
                                            /> */}
                                                </div>
                                            </div>
                                            <div className='row spacingBetweenRows'>
                                                <div className="col-md-4">
                                                    <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                        {/* {t(`Holiday Type`)} */}
                                                        {getValueFromResource('Holiday Type', dispatch, t)}
                                                        <div
                                                            style={{marginBottom: "2px"}}
                                                            data-tooltip-id="tooltip-description"
                                                            data-tooltip-content={getValueFromResource('Assign the holiday calendar that determines which public holidays apply to the employee.', dispatch, t)}
                                                        >
                                                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon"/>
                                                        </div>
                                                    </label>
                                                    <Select
                                                        value={employeeResponse.HolidayType.filter((x: any) => x.value == employeeValues.AccountHolidayTypeId)}
                                                        className="basic-single fs-7 fw-normal"
                                                        classNamePrefix="select"
                                                        name="holidaytypeList"
                                                        onChange={(e, name) => onChange(e, name)}
                                                        options={employeeResponse.HolidayType}
                                                        styles={dropDownSelectionStyles}
                                                        maxMenuHeight={maxMenuHeight}
                                                    />
                                                </div>
                                                <div className="col-md-4">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t(`TimeZone`)} */}
                                                        {getValueFromResource('TimeZone', dispatch, t)}
                                                    </label>
                                                    <Select
                                                        //value={employeeResponse.TimeZone.filter((x: any) => x.value == employeeValues.TimeZoneId)}
                                                        value={employeeResponse.TimeZone.filter((x: any) => x.value == values.TimeZoneId)}
                                                        className="basic-single fs-7 fw-normal"
                                                        classNamePrefix="select"
                                                        // name="timezoneList"
                                                        // onChange={(e, name) => onChange(e, name)}
                                                        name="TimeZoneId"
                                                        id='TimeZoneId'
                                                        onChange={(selectedOption: any) => {
                                                            handleChange({
                                                                target: {
                                                                    id: "TimeZoneId",
                                                                    value: selectedOption?.value
                                                                },
                                                            });
                                                        }}
                                                        options={employeeResponse.TimeZone}
                                                        styles={dropDownSelectionStyles}
                                                        maxMenuHeight={maxMenuHeight}
                                                    />
                                                    <div>
                                                        {touched.TimeZoneId && errors.TimeZoneId &&
                                                            <p className='errorMsg'>{errors.TimeZoneId as string}</p>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                        {/* {t(`Employee Type`)} */}
                                                        {getValueFromResource('Employee Type', dispatch, t)}
                                                        <div
                                                            style={{marginBottom: "2px"}}
                                                            data-tooltip-id="tooltip-description"
                                                            data-tooltip-content={getValueFromResource('Categorizes the employee, such as Full-Time, Part-Time, Contractor, Temporary, or Intern.', dispatch, t)}
                                                        >
                                                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon"/>
                                                        </div>
                                                    </label>
                                                    <Select
                                                        //value={employeeResponse.EmployeeType.filter((x: any) => x.value == employeeValues.AccountEmployeeTypeId)}
                                                        value={employeeResponse.EmployeeType.filter((x: any) => x.value == values.AccountEmployeeTypeId)}
                                                        className="basic-single fs-7 fw-normal"
                                                        classNamePrefix="select"
                                                        // name="employeetypeList"
                                                        // onChange={(e, name) => onChange(e, name)}
                                                        name="AccountEmployeeTypeId"
                                                        id='AccountEmployeeTypeId'
                                                        onChange={(selectedOption: any) => {
                                                            handleChange({
                                                                target: {
                                                                    id: "AccountEmployeeTypeId",
                                                                    value: selectedOption?.value
                                                                },
                                                            });
                                                        }}
                                                        options={employeeResponse.EmployeeType}
                                                        styles={dropDownSelectionStyles}
                                                        maxMenuHeight={maxMenuHeight}
                                                    />
                                                    <div>
                                                        {touched.AccountEmployeeTypeId && errors.AccountEmployeeTypeId &&
                                                            <p className='errorMsg'>{errors.AccountEmployeeTypeId as string}</p>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='row spacingBetweenRows'>
                                                {/* <div className="col-md-4">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {getValueFromResource('Employee Pin', dispatch, t)}
                                                    </label>
                                                    <div className="wrapper">
                                                        <input
                                                            name="employeePinCode"
                                                            type="text"
                                                            id="employeePinCode"
                                                            className="form-control input-disp-valid fs-7 fw-normal"
                                                            value={employeeValues.pinCode}
                                                            onChange={handleTextChange}
                                                            style={{ flex: 1 }}
                                                        />
                                                        <i className="insideField-Icons fa fa-refresh text-gray cursor-pointer"
                                                            onClick={handleRegeneratePin}
                                                        ></i> */}
                                                {/* <i className="insideField-Icons ki-outline ki-calendar text-gray"></i> */}
                                                {/* </div> */}
                                                {/* <div className="employee-pin" style={{ display: 'flex', alignItems: 'center' }}>
                                                <button
                                                    id="btnRegenerateEmployeePin"
                                                    className="btn btn-primary"
                                                    title="Regenerate Employee Pin"
                                                    type="button"
                                                    style={{ cursor: 'pointer', height: '40px', padding: '0 13px' }}
                                                    onClick={handleRegeneratePin}
                                                >
                                                    <i className="fa fa-refresh" style={{ fontSize: '12px !important' }}></i>
                                                </button>
                                            </div> */}
                                                {/* </div> */}
                                                {/* <div className="col-md-4">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {getValueFromResource('Shift', dispatch, t)}
                                                    </label>
                                                    <Select
                                                        value={employeeResponse.Shift.filter((x: any) => x.value == employeeValues.AccountShiftId)}
                                                        className="basic-single fs-7 fw-normal"
                                                        classNamePrefix="select"
                                                        name="shiftList"
                                                        onChange={(e, name) => onChange(e, name)}
                                                        options={employeeResponse.Shift}
                                                        styles={dropDownSelectionStyles}
                                                        maxMenuHeight={maxMenuHeight}
                                                        menuPlacement="auto"
                                                        menuPosition="fixed"
                                                    />
                                                </div> */}
                                                <div className="col-md-4">
                                                    <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                        {/* {t(`Expense Policy`)} */}
                                                        {getValueFromResource('Expense Policy', dispatch, t)}
                                                        <div
                                                            style={{marginBottom: "2px"}}
                                                            data-tooltip-id="tooltip-description"
                                                            data-tooltip-content={getValueFromResource('Assign the expense reimbursement policy that governs allowable expenses and approval rules.', dispatch, t)}
                                                        >
                                                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon"/>
                                                        </div>
                                                    </label>
                                                    <Select
                                                        value={employeeResponse.ExpensePolicy.filter((x: any) => x.value == employeeValues.AccountExpensePolicyId)}
                                                        className="basic-single fs-7 fw-normal"
                                                        classNamePrefix="select"
                                                        name="expensepolicyList"
                                                        onChange={(e, name) => onChange(e, name)}
                                                        options={employeeResponse.ExpensePolicy}
                                                        styles={dropDownSelectionStyles}
                                                        maxMenuHeight={maxMenuHeight}
                                                        menuPlacement="auto"
                                                        menuPosition="fixed"
                                                    />
                                                </div>

                                                <div className="col-md-4">
                                                    <label className="form-label fs-7 fw-normal mb-3 d-flex align-items-center gap-1">
                                                        {getValueFromResource('Auto-Approve Timesheet', dispatch, t)}
                                                        <div
                                                            style={{ marginBottom: "2px" }}
                                                            data-tooltip-id="tooltip-description"
                                                            data-tooltip-content={getValueFromResource(
                                                                `Enable this option to override the individual project's timesheet approval settings for this employee. Submitted timesheets will no longer require approval.`,
                                                                dispatch,
                                                                t
                                                            )}
                                                        >
                                                            <img
                                                                src={infoSVG}
                                                                alt=""
                                                                width={12}
                                                                height={12}
                                                                className="tooltip-info-icon"
                                                            />
                                                        </div>
                                                    </label>

                                                      <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                        <input className="form-check-input fs-7 fw-normal h-20px w-30px"
                                                            type="checkbox"
                                                            checked={employeeValues.IsTimesheetAutoApproval}
                                                            id="IsTimesheetAutoApproval"
                                                            name="IsTimesheetAutoApproval"
                                                            onChange={(e) => { onSwitch(e) }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={clsx('tab-pane', { active: tab === 'Other' })}>
                                            <div className='row'>
                                                <div className="col-md-4">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t(`Job Title`)} */}
                                                        {getValueFromResource('Job Title', dispatch, t)}
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control fs-7 fw-normal"
                                                        id='JobTitle'
                                                        value={employeeValues.JobTitle}
                                                        onChange={handleTextChange}
                                                    />
                                                </div>
                                                <div className="col-md-4">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t(`Hired Date`)} */}
                                                        {getValueFromResource('Hired Date', dispatch, t)}
                                                    </label>
                                                    <div className="wrapper">
                                                        <DatePicker
                                                            selected={employeeValues.HiredDate}
                                                            onChange={(date) => onDateChange(date, "HiredDate")}
                                                            calendarStartDay={calendarStartDay}
                                                            className="form-control dataPicker form-control-dark btn-icon-dark btn-text-dark fs-7 fw-normal"
                                                            dateFormat={CurrentCultureDateFormat.toString()}
                                                        >
                                                        </DatePicker>
                                                        <i className="insideField-Icons ki-outline ki-calendar text-gray"></i>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t(`Termination Date`)} */}
                                                        {getValueFromResource('Termination Date', dispatch, t)}
                                                    </label>
                                                    <div className="wrapper">
                                                        <DatePicker
                                                            //selected={ accountemployeeid === 0 ? null : employeeValues.TerminationDate }
                                                            selected={employeeValues.TerminationDate}
                                                            onChange={(date) => onDateChange(date, "TerminationDate")}
                                                            calendarStartDay={calendarStartDay}
                                                            className="form-control dataPicker form-control-dark btn-icon-dark btn-text-dark  fs-7 fw-normal"
                                                            dateFormat={CurrentCultureDateFormat.toString()}
                                                        >
                                                        </DatePicker>
                                                        <i className="insideField-Icons ki-outline ki-calendar text-gray"></i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='row mt-4'>
                                                {accountemployeeid > 0 &&
                                                    <div className="col-md-4">
                                                        <label className="form-label fs-7 fw-normal mb-3">
                                                            {/* {t('Show Employee Profile Picture')} */}
                                                            {getValueFromResource('Show Employee Profile Picture', dispatch, t)}
                                                        </label>
                                                        <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                            <input className="form-check-input fs-7 fw-normal h-20px w-30px"
                                                                type="checkbox"
                                                                checked={employeeValues.IsShowEmployeeProfilePicture}
                                                                id="IsShowEmployeeProfilePicture"
                                                                name="IsShowEmployeeProfilePicture"
                                                                onChange={(e) => { onSwitch(e) }}
                                                            />
                                                        </div>
                                                    </div>}
                                                <div className="col-md-4">
                                                    <label className="form-label fs-7 fw-normal mb-3">
                                                        {/* {t('Enable Time In/Out Option')} */}
                                                        {getValueFromResource('Enable Time In/Out Option', dispatch, t)}
                                                    </label>
                                                    <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                        <input className="form-check-input fs-7 fw-normal h-20px w-30px"
                                                            type="checkbox"
                                                            checked={employeeValues.AllowAttendanceFromWebApp}
                                                            id="IsTimeInOutAvailable"
                                                            name="IsTimeInOutAvailable"
                                                            onChange={(e) => { onSwitch(e) }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <label className="form-label fs-7 fw-normal mb-3">
                                                        {/* {t('Force Password Change')} */}
                                                        {getValueFromResource('Force Password Change', dispatch, t)}
                                                    </label>
                                                    <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                        <input className="form-check-input fs-7 fw-normal h-20px w-30px"
                                                            type="checkbox"
                                                            checked={employeeValues.IsForcePasswordChange}
                                                            id="IsForcePasswordChange"
                                                            name="IsForcePasswordChange"
                                                            onChange={(e) => { onSwitch(e) }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='row mt-4'>
                                                <div className="col-md-4">
                                                    <label
                                                        className="fs-7 fw-normal mb-2">
                                                        {/* {t('Selected color code:')} */}
                                                        {getValueFromResource('Selected color code:', dispatch, t)}
                                                    </label>
                                                    <div className="input-group" style={{ position: 'relative' }}>
                                                        <input
                                                            type="text"
                                                            id="ProfilePictureColorCode"
                                                            value={employeeValues.ProfilePictureColor}
                                                            placeholder=
                                                            // {t('Choose a color')}
                                                            {getValueFromResource('Choose a color', dispatch, t)}
                                                            className="form-control fs-7 fw-normal"
                                                            size={7}
                                                            onChange={handleTextChange}
                                                            readOnly
                                                        />
                                                        <input
                                                            type="color"
                                                            id="ProfilePictureColor"
                                                            value={employeeValues.ProfilePictureColor}
                                                            onChange={handleColorChange}
                                                            style={{
                                                                position: 'absolute', right: '1px', top: '50%', transform: 'translateY(-50%)', height: '38px', borderBottomRightRadius: '1px', borderTopRightRadius: '1px', padding: '0', background: 'none', cursor: 'pointer'
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                {accountemployeeid > 0 && enableUploadFeature &&
                                                    <div className="col-md-4">
                                                        <label className="form-label fs-7 fw-normal mb-2">
                                                            {/* {t('Profile Picture')} */}
                                                            {getValueFromResource('Profile Picture', dispatch, t)}
                                                        </label>
                                                        <input className="mt-2"
                                                            type="file"
                                                            accept=".png,.gif,.jpeg,.jpg"
                                                            onChange={(event) => handleFileChange(event, employeeValues.AccountEmployeeId !== 0 ? employeeValues.AccountEmployeeId : 0)}
                                                            // onChange={handleFileChange}
                                                            style={{ marginRight: '20px' }}
                                                        />
                                                    </div>
                                                }
                                                {accountemployeeid > 0 && enableUploadFeature &&
                                                    <div className="col-md-4">
                                                        <label className="form-label fs-7 fw-normal mb-2">
                                                            {/* {t('Electronic Signature')} */}
                                                            {getValueFromResource('Electronic Signature', dispatch, t)}
                                                        </label>
                                                        <input className="mt-2"
                                                            type="file"
                                                            accept=".png,.gif,.jpeg,.jpg"
                                                            //onChange={handleFileElectronicSignature}
                                                            onChange={(event) => handleFileElectronicSignature(event, employeeValues.AccountEmployeeId !== 0 ? employeeValues.AccountEmployeeId : 0)}
                                                            style={{ marginRight: '20px' }}
                                                        />
                                                    </div>}
                                            </div>
                                            <div className='row mt-4'>
                                                {(accountemployeeid !== 0 && accountemployeeid !== sessionAccountEmployeeId) ? (
                                                    <div className="col-md-6">
                                                        <label className="form-label fs-7 fw-normal mb-2">
                                                            {/* {t(`Disabled`)} */}
                                                            {getValueFromResource('Disabled', dispatch, t)}
                                                        </label>
                                                        <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                            <input
                                                                className="form-check-input h-20px w-30px  mt-2"
                                                                type='checkbox'
                                                                name='IsDisabled'
                                                                checked={employeeValues.IsDisabled}
                                                                onChange={(e) => { onSwitch(e) }}
                                                            />
                                                        </div>
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                        {customFieldsArray && customFieldsArray.length > 0 &&
                                            <div className={clsx('tab-pane', { active: tab === 'CustomField' })}>
                                                <div className='row'>
                                                    {customFieldsArray.filter((x: any) => !x.IsDisabled && x.DatabaseFieldName !== '').map((x: any, index: any) =>
                                                        <Fragment key={index}>
                                                            {x.MasterCustomDataTypeName == "Drop-Down" && (
                                                                <>
                                                                    <div key={index} className={"col-md-6 mb-3 "}>
                                                                        <label className={"form-label fs-7 fw-normal mb-2"}>{x.CustomFieldCaption}</label>
                                                                        <Select
                                                                            name={x.DatabaseFieldName}
                                                                            className="basic-single fs-7 fw-normal"
                                                                            onChange={(e: any) => setFieldValue(x.DatabaseFieldName, e?.value)}
                                                                            styles={dropDownSelectionStyles}
                                                                            value={values[x.DatabaseFieldName] ? { value: values[x.DatabaseFieldName], label: values[x.DatabaseFieldName] } : { value: 'None', label: 'None' }}
                                                                            options={[
                                                                                { value: 'None', label: 'None' },  // Add "None" option at the start
                                                                                ...x.DropDownOptions
                                                                                    ? x.DropDownOptions.split("+").map((value: any) => ({ value, label: value }))
                                                                                    : []
                                                                            ]}
                                                                            //options={x.DropDownOptions ? x.DropDownOptions.split("+").map((value: any, index: any) => ({ value, label: value })) : []}
                                                                            required={x.IsRequired ? x.IsRequired : ""}
                                                                            maxMenuHeight={maxMenuHeight}
                                                                        />
                                                                        {(x.IsRequired || (!x.IsRequired && x.MasterCustomDataTypeName === 'Drop-Down')) && (
                                                                            <div style={{ paddingRight: 20 }}>
                                                                                {touched[x.DatabaseFieldName] && errors[x.DatabaseFieldName] &&
                                                                                    <p className='errorMsg'>{errors[x.DatabaseFieldName] as string}</p>
                                                                                }
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </>
                                                            )}
                                                            {x.MasterCustomDataTypeName == "Date" && (
                                                                <>
                                                                    <div key={index} className={"col-md-6 mb-3"}>
                                                                        <label className={"form-label fs-7 fw-normal mb-2"}>{x.CustomFieldCaption}</label>
                                                                        <div className="wrapper">
                                                                            <DatePicker
                                                                                name={x.DatabaseFieldName}
                                                                                //onChange={(date) => setFieldValue(`${x.DatabaseFieldName}`, date)}
                                                                                //selected={(values[x.DatabaseFieldName] ? values[x.DatabaseFieldName] : new Date())}
                                                                                onChange={(date) => setFieldValue(`${x.DatabaseFieldName}`, date ? moment(date).format(customFieldInsertionFormat) : moment(new Date()).format(customFieldInsertionFormat))}
                                                                                selected={(values[x.DatabaseFieldName] ? dateFormatByAccountCulture(values[x.DatabaseFieldName], cultureInfoName.toString()) : new Date())}
                                                                                dateFormat={CurrentCultureDateFormat.toString()}
                                                                                calendarStartDay={calendarStartDay}
                                                                                className="form-control form-con fs-7 fw-normal col-md-1"
                                                                            // onBlur={() => handleBlurValidateAll(setFieldTouched, values, validateForm)}
                                                                            />
                                                                            <i className="insideField-Icons ki-outline ki-calendar text-gray"></i>
                                                                        </div>
                                                                        {/* <DatePicker
                                                                        name={x.DatabaseFieldName}
                                                                        // onChange={(date) => setFieldValue(`${x.DatabaseFieldName}`, moment(date).format(CurrentCultureDateFormat.toUpperCase()))}
                                                                        // selected={(values[x.DatabaseFieldName] ? moment(values[x.DatabaseFieldName], CurrentCultureDateFormat.toUpperCase()).toDate() : null)}
                                                                        onChange={(date) => setFieldValue(`${x.DatabaseFieldName}`, date ? moment(date).format(CurrentCultureDateFormat.toUpperCase()) : moment().format(CurrentCultureDateFormat.toUpperCase()))}
                                                                        selected={(values[x.DatabaseFieldName] ? moment(values[x.DatabaseFieldName], CurrentCultureDateFormat.toUpperCase()).toDate() : moment().toDate())}
                                                                        className="form-control form-con fs-7 fw-normal col-md-1"
                                                                        onBlur={() => handleBlurValidateAll(setFieldTouched, values, validateForm)}
                                                                    /> */}
                                                                        {(x.IsRequired || (!x.IsRequired && x.MasterCustomDataTypeName === 'Date')) && (
                                                                            <div style={{ paddingRight: 20 }}>
                                                                                {touched[x.DatabaseFieldName] && errors[x.DatabaseFieldName] &&
                                                                                    <p className='errorMsg'>{errors[x.DatabaseFieldName] as string}</p>
                                                                                }
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </>
                                                            )}
                                                            {(x.MasterCustomDataTypeName == "Text") && (
                                                                <div key={index} className={"col-md-6 mb-3"}>
                                                                    <label className={"form-label fs-7 fw-normal mb-2"}>{x.CustomFieldCaption}</label>
                                                                    <input
                                                                        name={x.DatabaseFieldName}
                                                                        id={x.DatabaseFieldName}
                                                                        //value={values[x.DatabaseFieldName]}
                                                                        value={values[x.DatabaseFieldName] ? values[x.DatabaseFieldName] : ''}
                                                                        //value={(values[x.DatabaseFieldName] !== null && values[x.DatabaseFieldName] !== undefined && values[x.DatabaseFieldName] !== '') ? values[x.DatabaseFieldName] : ''}
                                                                        onChange={handleChange(`${x.DatabaseFieldName}`)}
                                                                        className={"form-control form-con input-sm custom-field custom-field"}
                                                                        //maxLength={x.MaximumLength ? x.MaximumLength : ""}
                                                                        required={x.IsRequired ? x.IsRequired : ""}
                                                                        type="text"
                                                                    // onBlur={() => setFieldTouched(`${x.DatabaseFieldName}`)}
                                                                    //onBlur={() => handleBlurValidateAll(setFieldTouched, values, validateForm)}
                                                                    />
                                                                    {(x.IsRequired || (!x.IsRequired && x.MasterCustomDataTypeName === 'Text')) && (
                                                                        <div style={{ paddingRight: 20 }}>
                                                                            {touched[x.DatabaseFieldName] && errors[x.DatabaseFieldName] &&
                                                                                <p className='errorMsg'>{errors[x.DatabaseFieldName] as string}</p>
                                                                            }
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            )}
                                                            {(x.MasterCustomDataTypeName == "Number") && (
                                                                <div key={index} className={"col-md-6 mb-3"}>
                                                                    <label className={"form-label fs-7 fw-normal mb-2"}>{x.CustomFieldCaption}</label>
                                                                    <input
                                                                        type="text"
                                                                        name={x.DatabaseFieldName}
                                                                        id={x.DatabaseFieldName}
                                                                        value={values[x.DatabaseFieldName] ? values[x.DatabaseFieldName] : ''}
                                                                        onChange={(e) => {
                                                                            const value = e.target.value;
                                                                            if (validateCultureNumber(value, cultureInfoName.toString(), decimalPlaces)) {
                                                                                setFieldValue(x.DatabaseFieldName, value);
                                                                            }
                                                                        }}
                                                                        onBlur={(e) => {
                                                                            const formatted = formatNumberCustomoriginal(
                                                                                cultureInfoName.toString(),
                                                                                e.target.value,
                                                                                decimalPlaces
                                                                            );
                                                                            setFieldValue(x.DatabaseFieldName, formatted);
                                                                        }}
                                                                        className={"form-control form-con input-sm custom-field custom-field"}
                                                                        required={x.IsRequired ? x.IsRequired : ""}
                                                                    />
                                                                    {(x.IsRequired || (!x.IsRequired && x.MasterCustomDataTypeName === 'Number')) && (
                                                                        <div style={{ paddingRight: 20 }}>
                                                                            {touched[x.DatabaseFieldName] && errors[x.DatabaseFieldName] &&
                                                                                <p className='errorMsg'>{errors[x.DatabaseFieldName] as string}</p>
                                                                            }
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </Fragment>
                                                    )}
                                                    {/* {customFieldsArray.filter((x: any) => !x.IsDisabled && x.DatabaseFieldName !== '').map((x: any, index: any) =>
                                                <>
                                                    {x.MasterCustomDataTypeName == "Drop-Down" && (
                                                        <>
                                                            <div key={index} className={"col-md-6 mb-3 "}>
                                                                <label className={"form-label fs-7 fw-normal mb-2"}>{x.CustomFieldCaption}</label>
                                                                <Select
                                                                    name={x.DatabaseFieldName}
                                                                    className="basic-single fs-7 fw-normal"
                                                                    onChange={(e) => setFieldValue(x.DatabaseFieldName, e?.value)}
                                                                    value={values[x.DatabaseFieldName] ? { value: values[x.DatabaseFieldName], label: values[x.DatabaseFieldName] } : { value: 'None', label: 'None' }}
                                                                    options={x.DropDownOptions ? x.DropDownOptions.split("+").map((value: any, index: any) => ({ value, label: value })) : []}
                                                                    required={x.IsRequired ? x.IsRequired : ""}
                                                                />
                                                                {(x.IsRequired || (!x.IsRequired && x.MasterCustomDataTypeName === 'Drop-Down')) && (
                                                                    <div style={{ paddingRight: 20 }}>
                                                                        {touched[x.DatabaseFieldName] && errors[x.DatabaseFieldName] &&
                                                                            <p className='errorMsg'>{errors[x.DatabaseFieldName] as string}</p>
                                                                        }
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </>
                                                    )}
                                                    {x.MasterCustomDataTypeName == "Date" && (
                                                        <>
                                                            <div key={index} className={"col-md-6 mb-3"}>
                                                                <label className={"form-label fs-7 fw-normal mb-2"}>{x.CustomFieldCaption}</label>
                                                                <DatePicker
                                                                    name={x.DatabaseFieldName}
                                                                    onChange={(date) => setFieldValue(`${x.DatabaseFieldName}`, date ? moment(date).format(CurrentCultureDateFormat.toUpperCase()) : moment().format(CurrentCultureDateFormat.toUpperCase()))}
                                                                    selected={(values[x.DatabaseFieldName] ? moment(values[x.DatabaseFieldName], CurrentCultureDateFormat.toUpperCase()).toDate() : moment().toDate())}
                                                                    className="form-control form-con fs-7 fw-normal col-md-1"
                                                                    onBlur={() => handleBlurValidateAll(setFieldTouched, values, validateForm)}
                                                                />
                                                                {(x.IsRequired || (!x.IsRequired && x.MasterCustomDataTypeName === 'Date')) && (
                                                                    <div style={{ paddingRight: 20 }}>
                                                                        {touched[x.DatabaseFieldName] && errors[x.DatabaseFieldName] &&
                                                                            <p className='errorMsg'>{errors[x.DatabaseFieldName] as string}</p>
                                                                        }
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </>
                                                    )}
                                                    {(x.MasterCustomDataTypeName == "Text") && (
                                                        <div key={index} className={"col-md-6 mb-3"}>
                                                            <label className={"form-label fs-7 fw-normal mb-2"}>{x.CustomFieldCaption}</label>
                                                            <input
                                                                name={x.DatabaseFieldName}
                                                                id={x.DatabaseFieldName}
                                                                value={values[x.DatabaseFieldName] ? values[x.DatabaseFieldName] : ''}
                                                                onChange={handleChange(`${x.DatabaseFieldName}`)}
                                                                className={"form-control form-con input-sm custom-field custom-field"}
                                                                required={x.IsRequired ? x.IsRequired : ""}
                                                                type="text"
                                                                onBlur={() => handleBlurValidateAll(setFieldTouched, values, validateForm)}
                                                            />
                                                            {(x.IsRequired || (!x.IsRequired && x.MasterCustomDataTypeName === 'Text')) && (
                                                                <div style={{ paddingRight: 20 }}>
                                                                    {touched[x.DatabaseFieldName] && errors[x.DatabaseFieldName] &&
                                                                        <p className='errorMsg'>{errors[x.DatabaseFieldName] as string}</p>
                                                                    }
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                    {(x.MasterCustomDataTypeName == "Number") && (
                                                        <div key={index} className={"col-md-6 mb-3"}>
                                                            <label className={"form-label fs-7 fw-normal mb-2"}>{x.CustomFieldCaption}</label>
                                                            <input
                                                                name={x.DatabaseFieldName}
                                                                id={x.DatabaseFieldName}
                                                                value={values[x.DatabaseFieldName] ? values[x.DatabaseFieldName] : ''}
                                                                onChange={handleChange(`${x.DatabaseFieldName}`)}
                                                                className={"form-control form-con input-sm custom-field custom-field"}
                                                                max={x.MaximumValue !== undefined ? parseFloat(x.MaximumValue) : undefined}
                                                                min={x.MinimumValue !== undefined ? parseFloat(x.MinimumValue) : undefined}
                                                                required={x.IsRequired ? x.IsRequired : ""}
                                                                type="number"
                                                                onBlur={() => handleBlurValidateAll(setFieldTouched, values, validateForm)}
                                                            />
                                                            {(x.IsRequired || (!x.IsRequired && x.MasterCustomDataTypeName === 'Number')) && (
                                                                <div style={{ paddingRight: 20 }}>
                                                                    {touched[x.DatabaseFieldName] && errors[x.DatabaseFieldName] &&
                                                                        <p className='errorMsg'>{errors[x.DatabaseFieldName] as string}</p>
                                                                    }
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                </>
                                            )} */}
                                                </div>
                                            </div>
                                        }
                                    </div>
                                    {/* </form> */}
                                </>}
                                {/* Display form-level error summary */}
                                {showErrorSummary && Object.keys(errors).length > 0 && (
                                    <div className="mt-3 alert alert-danger">
                                        <strong>
                                            {/* {t('Error Summary')}: */}
                                            {getValueFromResource('Error Summary', dispatch, t)}:
                                        </strong>
                                        <ul>
                                            {Object.keys(errors).map((fieldName, index) => (
                                                <li key={index}>{errors[fieldName] as string}</li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </div>
                            <div className='card-footer pt-4 '>
                                <div className='d-flex flex-stack float-end'>
                                    <button
                                        ref={closeButtonRef}
                                        type="button"
                                        className="btn btn-secondary btn-bs-btn-font-weight  me-2 btn-sm fs-7"
                                        id="kt_OffCanvas"
                                        onClick={handleCloseOnClickEvent}
                                    >
                                        {/* {t('Cancel')} */}
                                        {getValueFromResource('Cancel', dispatch, t)}
                                    </button>
                                    <button
                                        className="btn btn-primary btn-bs-btn-font-weight me-2 btn-sm fs-7"
                                        type='button'
                                        data-kt-element='send'
                                        onClick={() => {
                                            setShowErrorSummary(true);
                                            handleSubmit();
                                        }}
                                        //onClick={() => handleSubmit()}
                                        //disabled={!isValid || !isEmailAvailabler}
                                        disabled={(IsLicenseExpired === "true" && accountemployeeid === 0) || !isEmailAvailabler}

                                    >
                                        {/* {t('Save')} */}
                                        {getValueFromResource('Save', dispatch, t)}
                                    </button>
                                </div>
                            </div>
                        </Fragment>
                    )
                }}
            </Formik>
            <ReactTooltip
                id="tooltip-description"
                style={TOOLTIP_STYLE}
                place="top"
                delayShow={100}
                delayHide={100}
                clickable
                render={({ content }) => {
                    const isLongContent = content && content?.length > 90;
                    return (
                        <div style={{ maxWidth: isLongContent ? 380 : 220 }}>
                            {content}
                        </div>
                    );
                }}
            />
        </>
    )
}

const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: '100%', minHeight: '43px', height: '43px' }),
}

export default EmployeeAddUpdate